var map = {
	"./_routes.json": [
		37572
	],
	"./blog/pages/p1_lv.json": [
		24587,
		24587
	],
	"./blog/pages/p2_lv.json": [
		32511,
		32511
	],
	"./blog/pages/p3_lv.json": [
		399,
		399
	],
	"./blog/pages/p4_lv.json": [
		34627,
		34627
	],
	"./blog/pages/p5_lv.json": [
		97466,
		97466
	],
	"./blog/pages/p6_lv.json": [
		78878,
		78878
	],
	"./blog/pages/p7_lv.json": [
		58058,
		58058
	],
	"./blog/pages/p8_lv.json": [
		66705,
		66705
	],
	"./blog/posts/5-svarigi-jautajumi-par-piena-seniti_lv.json": [
		81970,
		81970
	],
	"./blog/posts/9-ieradumi-veseligam-holesterina-limenim_lv.json": [
		95113,
		95113
	],
	"./blog/posts/a-vitamina-trukums-celoni-simptomi-un-arstesana_lv.json": [
		51477,
		51477
	],
	"./blog/posts/alat_lv.json": [
		17777,
		17777
	],
	"./blog/posts/assinspiediena-kategorijas-ko-tavi-raditaji-nozime_lv.json": [
		49655,
		49655
	],
	"./blog/posts/attalinato-konsultaciju-ieguvumi_lv.json": [
		6971,
		6971
	],
	"./blog/posts/aukstumpumpa-klat-ko-darit_lv.json": [
		32446,
		32446
	],
	"./blog/posts/b12-vitamina-trukums-simptomi-celoni-un-arstesana_lv.json": [
		84325,
		84325
	],
	"./blog/posts/berns-un-drudzis_lv.json": [
		98564,
		98564
	],
	"./blog/posts/bernu-psihiska-veseliba-un-attistiba-ka-atpazit-un-atbalstit-bernu-emocionalo-labklajibu_lv.json": [
		76799,
		76799
	],
	"./blog/posts/bernu-un-pusaudzu-psihiskie-traucejumi-ka-atpazit-un-sniegt-atbalstu-_lv.json": [
		82127,
		82127
	],
	"./blog/posts/cik-daudz-kafijas-ir-par-daudz_lv.json": [
		27679,
		27679
	],
	"./blog/posts/d-vitamina-trukums-celoni-simptomi-un-noversana_lv.json": [
		79712,
		79712
	],
	"./blog/posts/dermatologa-konsultacijas-pec-vasaras_lv.json": [
		67076,
		67076
	],
	"./blog/posts/diendusas-speks-labakai-dzivei_lv.json": [
		9565,
		9565
	],
	"./blog/posts/digitala-pasaule-un-bernu-psihiska-veseliba_lv.json": [
		49502,
		49502
	],
	"./blog/posts/dzelzs-deficita-anemija-celoni-simptomi-un-arstesana_lv.json": [
		5531,
		5531
	],
	"./blog/posts/dzelzs-un-feritins-asinis_lv.json": [
		54718,
		54718
	],
	"./blog/posts/dzemdes-kakla-vezis-kas-jazina-un-ka-pasargat-sevi-un-savu-gimeni_lv.json": [
		897,
		897
	],
	"./blog/posts/endokrinologs-kas-tas-ir-un-ka-spej-palidzet_lv.json": [
		1895,
		1895
	],
	"./blog/posts/fizisko-aktivitāšu-loma-ikdienā-un-fizioterapeita-nozīme-veselības-uzturēšanā_lv.json": [
		45138,
		45138
	],
	"./blog/posts/gastrits-kadi-ir-galvenie-iemesli-un-ka-to-arstet_lv.json": [
		36574,
		36574
	],
	"./blog/posts/gimenes-un-vides-ietekme-uz-berna-psihisko-veselibu_lv.json": [
		12297,
		12297
	],
	"./blog/posts/hemoroidi-simptomi-celoni-un-arstesana_lv.json": [
		47618,
		47618
	],
	"./blog/posts/izmeri-sirds-veselibu_lv.json": [
		97894,
		97894
	],
	"./blog/posts/iztiri-ausis-vai-varbut-ne_lv.json": [
		50219,
		50219
	],
	"./blog/posts/k-vitamina-trukums-celoni-simptomi-un-arstesana_lv.json": [
		98360,
		98360
	],
	"./blog/posts/ka-atgriezties-ikdienas-rutina-un-saglabat-lidzsvaru-starp-darbu-un-veselibu_lv.json": [
		43916,
		43916
	],
	"./blog/posts/ka-atguties-pec-paresanas_lv.json": [
		44794,
		44794
	],
	"./blog/posts/ka-rupeties-par-savu-psihisko-veselibu-rudens-un-ziemas-sezona_lv.json": [
		77450,
		77450
	],
	"./blog/posts/ka-sagatavoties-arsta-vizitei_lv.json": [
		63013,
		63013
	],
	"./blog/posts/ka-saprast-savus-holesterina-rezultatus_lv.json": [
		67574,
		67574
	],
	"./blog/posts/ka-sevi-pasargat-no-bistamas-e-coli-bakterijas-_lv.json": [
		14099,
		14099
	],
	"./blog/posts/ka-uzturvielu-deficits-ietekme-organismu-un-veselibu-_lv.json": [
		44050,
		44050
	],
	"./blog/posts/kad-doties-pie-kardiologa_lv.json": [
		87256,
		87256
	],
	"./blog/posts/kadas-veselibas-parbaudes-javeic-profilaktiski-_lv.json": [
		23280,
		23280
	],
	"./blog/posts/kaitinosakie-no-kodejiem-odi_lv.json": [
		6727,
		6727
	],
	"./blog/posts/kas-ir-drudzis-un-ko-ar-to-iesakt_lv.json": [
		26498,
		26498
	],
	"./blog/posts/kas-var-liecinat-par-laima-slimibu_lv.json": [
		33009,
		33009
	],
	"./blog/posts/kas-var-liecinat-par-pankreatitu-jeb-aizkunga-dziedzera-iekaisumu_lv.json": [
		30301,
		30301
	],
	"./blog/posts/ko-dara-uztura-speciālists_lv.json": [
		8460,
		8460
	],
	"./blog/posts/ko-kermena-masas-indekss-var-pateikt-un-ko-ne_lv.json": [
		78140,
		78140
	],
	"./blog/posts/kruts-veseliba-profilakse-un-agrina-diagnostika-krusu-veselibas-menesi_lv.json": [
		93807,
		93807
	],
	"./blog/posts/kuru-arstu-izveleties-1-dala_lv.json": [
		79610,
		79610
	],
	"./blog/posts/kuru-arstu-izveleties-2-dala_lv.json": [
		42991,
		42991
	],
	"./blog/posts/lieldienu-paresanas-ka-lidzsvarot-svetku-prieku-ar-labsajutu_lv.json": [
		16511,
		16511
	],
	"./blog/posts/medon-uzsak-sadarbibu-ar-balcia-lai-piedavatu-attalinatas-arstu-konsultacijas-celojumu-apdrosinasanas-polises-ietvaros_lv.json": [
		74714,
		74714
	],
	"./blog/posts/melnais-pluskoks-ar-ko-tas-vertigs-veselibai-un-ka-to-uznemt_lv.json": [
		16710,
		16710
	],
	"./blog/posts/migla-galva_lv.json": [
		50057,
		50057
	],
	"./blog/posts/paaugstinats-asinspiediens-simptomi-riski-ka-samazinat_lv.json": [
		85625,
		85625
	],
	"./blog/posts/par-smeketaju-klepu_lv.json": [
		73484,
		73484
	],
	"./blog/posts/pasaules-pretveza-diena-ka-pasargat-sevi-un-savus-tuvakos_lv.json": [
		57284,
		57284
	],
	"./blog/posts/pavasara-alergija_lv.json": [
		2271,
		2271
	],
	"./blog/posts/psihiatra-loma-berna-arstesanas-procesa_lv.json": [
		53726,
		53726
	],
	"./blog/posts/rudens-sezona-un-skolas-sakums_lv.json": [
		4381,
		4381
	],
	"./blog/posts/rudens-ziemas-depresija_lv.json": [
		92640,
		92640
	],
	"./blog/posts/saules-aizsardzība-kā-izvēlēties-un-lietot-sauļošanās-krēmus_lv.json": [
		34363,
		34363
	],
	"./blog/posts/sekss-pec-60_lv.json": [
		71955,
		71955
	],
	"./blog/posts/sievietes-sirds-veseliba_lv.json": [
		65644,
		65644
	],
	"./blog/posts/simptomi-kas-var-liecinat-par-apendicitu_lv.json": [
		39971,
		39971
	],
	"./blog/posts/sirds-veseliba-viriesiem-pec-40-kapec-profilakse-ir-izskirosa-_lv.json": [
		31297,
		31297
	],
	"./blog/posts/stafilokoka-infekcijas-simptomi-celoni-un-arstesana_lv.json": [
		84351,
		84351
	],
	"./blog/posts/telemedicina-jaunas-iespejas-veselibas-aprupe_lv.json": [
		37244,
		37244
	],
	"./blog/posts/trauksme-ka-to-atpazit-un-parvaldit-ikdiena_lv.json": [
		58571,
		58571
	],
	"./blog/posts/urina-nesaturesana_lv.json": [
		81971,
		81971
	],
	"./blog/posts/utis-uzbrukuma-ka-atbrivoties-no-nevelamiem-galvas-viesiem-atri-un-efektivi-_lv.json": [
		82875,
		82875
	],
	"./blog/posts/vai-olas-tiesam-paaugstina-holesterinu-miti-un-patiesiba_lv.json": [
		73618,
		37878
	],
	"./blog/posts/vai-vienmer-vajag-zales-risinajumi-galvassapem-bez-medikamentiem_lv.json": [
		18923,
		18923
	],
	"./blog/posts/vasara-un-bērnu-veselība-drošība-ūdenī-un-uz-zemes_lv.json": [
		15726,
		15726
	],
	"./blog/posts/vecaku-un-pedagogu-loma-bernu-psihiskas-veselibas-atbalsta_lv.json": [
		39369,
		39369
	],
	"./blog/posts/vedera-krampji-muguras-sapes-un-migrena-ka-mazinat-menesreizu-diskomfortu-_lv.json": [
		35721,
		35721
	],
	"./blog/posts/vegetativa-distonija_lv.json": [
		52314,
		52314
	],
	"./blog/posts/vertigais-berzu-sula_lv.json": [
		94946,
		94946
	],
	"./blog/posts/veselibas-padomi-parejai-no-vasaras-uz-rudeni_lv.json": [
		33557,
		33557
	],
	"./blog/posts/zemenes-8-ieguvumi-veselibai_lv.json": [
		4151,
		4151
	],
	"./health-issues/adas-problemas/_all_en.json": [
		24064,
		24064
	],
	"./health-issues/adas-problemas/_all_lv.json": [
		71327,
		71327
	],
	"./health-issues/adas-problemas/_all_ru.json": [
		68781,
		68781
	],
	"./health-issues/adas-problemas/adas-senite_en.json": [
		34114,
		34114
	],
	"./health-issues/adas-problemas/adas-senite_lv.json": [
		94919,
		94919
	],
	"./health-issues/adas-problemas/adas-senite_ru.json": [
		94313,
		94313
	],
	"./health-issues/adas-problemas/adas-vezis_en.json": [
		70950,
		70950
	],
	"./health-issues/adas-problemas/adas-vezis_lv.json": [
		73050,
		73050
	],
	"./health-issues/adas-problemas/adas-vezis_ru.json": [
		53298,
		53298
	],
	"./health-issues/adas-problemas/akne_en.json": [
		81126,
		81126
	],
	"./health-issues/adas-problemas/akne_lv.json": [
		33839,
		33839
	],
	"./health-issues/adas-problemas/akne_ru.json": [
		30539,
		30539
	],
	"./health-issues/adas-problemas/alopecija_en.json": [
		27162,
		27162
	],
	"./health-issues/adas-problemas/alopecija_lv.json": [
		97727,
		97727
	],
	"./health-issues/adas-problemas/alopecija_ru.json": [
		75927,
		75927
	],
	"./health-issues/adas-problemas/angiomas_en.json": [
		84702,
		84702
	],
	"./health-issues/adas-problemas/angiomas_lv.json": [
		20502,
		20502
	],
	"./health-issues/adas-problemas/angiomas_ru.json": [
		83162,
		83162
	],
	"./health-issues/adas-problemas/atopiskais-dermatits_en.json": [
		38895,
		38895
	],
	"./health-issues/adas-problemas/atopiskais-dermatits_lv.json": [
		93446,
		93446
	],
	"./health-issues/adas-problemas/atopiskais-dermatits_ru.json": [
		88858,
		88858
	],
	"./health-issues/adas-problemas/dermatits_en.json": [
		94773,
		94773
	],
	"./health-issues/adas-problemas/dermatits_lv.json": [
		32086,
		32086
	],
	"./health-issues/adas-problemas/dermatits_ru.json": [
		47839,
		47839
	],
	"./health-issues/adas-problemas/ekzema_en.json": [
		94427,
		94427
	],
	"./health-issues/adas-problemas/ekzema_lv.json": [
		57692,
		57692
	],
	"./health-issues/adas-problemas/ekzema_ru.json": [
		89710,
		37342
	],
	"./health-issues/adas-problemas/herpes_en.json": [
		65739,
		65739
	],
	"./health-issues/adas-problemas/herpes_lv.json": [
		1511,
		1511
	],
	"./health-issues/adas-problemas/herpes_ru.json": [
		5035,
		5035
	],
	"./health-issues/adas-problemas/impetigo_en.json": [
		99613,
		99613
	],
	"./health-issues/adas-problemas/impetigo_lv.json": [
		13602,
		13602
	],
	"./health-issues/adas-problemas/impetigo_ru.json": [
		31838,
		31838
	],
	"./health-issues/adas-problemas/kaju-senite_en.json": [
		31211,
		31211
	],
	"./health-issues/adas-problemas/kaju-senite_lv.json": [
		41017,
		41017
	],
	"./health-issues/adas-problemas/kaju-senite_ru.json": [
		50485,
		50485
	],
	"./health-issues/adas-problemas/karpas_en.json": [
		50476,
		50476
	],
	"./health-issues/adas-problemas/karpas_lv.json": [
		44201,
		44201
	],
	"./health-issues/adas-problemas/karpas_ru.json": [
		93091,
		93091
	],
	"./health-issues/adas-problemas/kaskis_en.json": [
		74256,
		74256
	],
	"./health-issues/adas-problemas/kaskis_lv.json": [
		65592,
		65592
	],
	"./health-issues/adas-problemas/kaskis_ru.json": [
		80308,
		80308
	],
	"./health-issues/adas-problemas/koksaki-viruss_en.json": [
		94158,
		94158
	],
	"./health-issues/adas-problemas/koksaki-viruss_lv.json": [
		38664,
		38664
	],
	"./health-issues/adas-problemas/koksaki-viruss_ru.json": [
		74566,
		74566
	],
	"./health-issues/adas-problemas/melanoma_en.json": [
		26263,
		26263
	],
	"./health-issues/adas-problemas/melanoma_lv.json": [
		95,
		95
	],
	"./health-issues/adas-problemas/melanoma_ru.json": [
		35074,
		35074
	],
	"./health-issues/adas-problemas/nagu-senite_en.json": [
		54205,
		54205
	],
	"./health-issues/adas-problemas/nagu-senite_lv.json": [
		1856,
		1856
	],
	"./health-issues/adas-problemas/nagu-senite_ru.json": [
		80298,
		80298
	],
	"./health-issues/adas-problemas/piodermija_en.json": [
		22538,
		22538
	],
	"./health-issues/adas-problemas/piodermija_lv.json": [
		65897,
		65897
	],
	"./health-issues/adas-problemas/piodermija_ru.json": [
		33695,
		33695
	],
	"./health-issues/adas-problemas/psoriaze_en.json": [
		17422,
		17422
	],
	"./health-issues/adas-problemas/psoriaze_lv.json": [
		1309,
		1309
	],
	"./health-issues/adas-problemas/psoriaze_ru.json": [
		35286,
		35286
	],
	"./health-issues/adas-problemas/rozacija_en.json": [
		6984,
		6984
	],
	"./health-issues/adas-problemas/rozacija_lv.json": [
		34014,
		34014
	],
	"./health-issues/adas-problemas/rozacija_ru.json": [
		41391,
		41391
	],
	"./health-issues/adas-problemas/seborejiskais-dermatits_en.json": [
		65693,
		65693
	],
	"./health-issues/adas-problemas/seborejiskais-dermatits_lv.json": [
		42171,
		42171
	],
	"./health-issues/adas-problemas/seborejiskais-dermatits_ru.json": [
		59936,
		59936
	],
	"./health-issues/adas-problemas/sklerodermija_en.json": [
		78588,
		78588
	],
	"./health-issues/adas-problemas/sklerodermija_lv.json": [
		34763,
		34763
	],
	"./health-issues/adas-problemas/sklerodermija_ru.json": [
		5232,
		5232
	],
	"./health-issues/adas-problemas/vitiligo_en.json": [
		37887,
		37887
	],
	"./health-issues/adas-problemas/vitiligo_lv.json": [
		19174,
		19174
	],
	"./health-issues/adas-problemas/vitiligo_ru.json": [
		76316,
		76316
	],
	"./health-issues/adas-problemas_en.json": [
		41677,
		41677
	],
	"./health-issues/adas-problemas_lv.json": [
		45041,
		45041
	],
	"./health-issues/adas-problemas_ru.json": [
		14685,
		14685
	],
	"./health-issues/adas-senite_en.json": [
		83439,
		83439
	],
	"./health-issues/adas-senite_lv.json": [
		87565,
		87565
	],
	"./health-issues/adas-senite_ru.json": [
		7294,
		7294
	],
	"./health-issues/adas-vezis_en.json": [
		47330,
		47330
	],
	"./health-issues/adas-vezis_lv.json": [
		91190,
		91190
	],
	"./health-issues/adas-vezis_ru.json": [
		5254,
		5254
	],
	"./health-issues/adenoma_en.json": [
		51424,
		51424
	],
	"./health-issues/adenoma_lv.json": [
		30352,
		30352
	],
	"./health-issues/adenoma_ru.json": [
		98743,
		98743
	],
	"./health-issues/adisona-slimiba_en.json": [
		47023,
		78596
	],
	"./health-issues/adisona-slimiba_lv.json": [
		53487,
		53487
	],
	"./health-issues/adisona-slimiba_ru.json": [
		25153,
		25153
	],
	"./health-issues/aids_en.json": [
		77412,
		77412
	],
	"./health-issues/aids_lv.json": [
		8810,
		8810
	],
	"./health-issues/aids_ru.json": [
		99626,
		99626
	],
	"./health-issues/aizcietejumi-neerta-bet-loti-izplatita-problema-ka-to-risinat-_en.json": [
		47305,
		47305
	],
	"./health-issues/aizcietejumi-neerta-bet-loti-izplatita-problema-ka-to-risinat-_lv.json": [
		70268,
		70268
	],
	"./health-issues/aizcietejumi-neerta-bet-loti-izplatita-problema-ka-to-risinat-_ru.json": [
		87371,
		87371
	],
	"./health-issues/akne_en.json": [
		1084,
		1084
	],
	"./health-issues/akne_lv.json": [
		26599,
		26599
	],
	"./health-issues/akne_ru.json": [
		58135,
		58135
	],
	"./health-issues/aknu-ciroze_en.json": [
		24688,
		24688
	],
	"./health-issues/aknu-ciroze_lv.json": [
		54132,
		54132
	],
	"./health-issues/aknu-ciroze_ru.json": [
		37411,
		37411
	],
	"./health-issues/alcheimera-slimiba_en.json": [
		45157,
		45157
	],
	"./health-issues/alcheimera-slimiba_lv.json": [
		50411,
		50411
	],
	"./health-issues/alcheimera-slimiba_ru.json": [
		26292,
		26292
	],
	"./health-issues/alergijas-un-nepanesibas/_all_en.json": [
		85736,
		85736
	],
	"./health-issues/alergijas-un-nepanesibas/_all_lv.json": [
		67273,
		67273
	],
	"./health-issues/alergijas-un-nepanesibas/_all_ru.json": [
		65703,
		65703
	],
	"./health-issues/alergijas-un-nepanesibas/alergisks-rinits-ka-dzivot-vieglak-alergijas-sezona-_en.json": [
		72265,
		72265
	],
	"./health-issues/alergijas-un-nepanesibas/alergisks-rinits-ka-dzivot-vieglak-alergijas-sezona-_lv.json": [
		49808,
		49808
	],
	"./health-issues/alergijas-un-nepanesibas/alergisks-rinits-ka-dzivot-vieglak-alergijas-sezona-_ru.json": [
		54883,
		54883
	],
	"./health-issues/alergijas-un-nepanesibas/neraksturigi-simptomi-pec-ediena-iespejams-vainigs-ir-histamins_en.json": [
		65976,
		65976
	],
	"./health-issues/alergijas-un-nepanesibas/neraksturigi-simptomi-pec-ediena-iespejams-vainigs-ir-histamins_lv.json": [
		44837,
		44837
	],
	"./health-issues/alergijas-un-nepanesibas/neraksturigi-simptomi-pec-ediena-iespejams-vainigs-ir-histamins_ru.json": [
		71264,
		71264
	],
	"./health-issues/alergijas-un-nepanesibas/nieze-izsitumi-un-apsartums-vai-ta-ir-adas-alergija-_en.json": [
		90856,
		90856
	],
	"./health-issues/alergijas-un-nepanesibas/nieze-izsitumi-un-apsartums-vai-ta-ir-adas-alergija-_lv.json": [
		75759,
		75759
	],
	"./health-issues/alergijas-un-nepanesibas/nieze-izsitumi-un-apsartums-vai-ta-ir-adas-alergija-_ru.json": [
		94941,
		94941
	],
	"./health-issues/alergijas-un-nepanesibas/no-pavasara-prieka-uz-deguna-ciesanam-vai-tev-ir-siena-drudzis_en.json": [
		90773,
		90773
	],
	"./health-issues/alergijas-un-nepanesibas/no-pavasara-prieka-uz-deguna-ciesanam-vai-tev-ir-siena-drudzis_lv.json": [
		9663,
		9663
	],
	"./health-issues/alergijas-un-nepanesibas/no-pavasara-prieka-uz-deguna-ciesanam-vai-tev-ir-siena-drudzis_ru.json": [
		92357,
		92357
	],
	"./health-issues/alergijas-un-nepanesibas/no-vedera-pusanas-lidz-nogurumam-partikas-nepanesamibas-simptomi_en.json": [
		9359,
		9359
	],
	"./health-issues/alergijas-un-nepanesibas/no-vedera-pusanas-lidz-nogurumam-partikas-nepanesamibas-simptomi_lv.json": [
		47636,
		47636
	],
	"./health-issues/alergijas-un-nepanesibas/no-vedera-pusanas-lidz-nogurumam-partikas-nepanesamibas-simptomi_ru.json": [
		7375,
		7375
	],
	"./health-issues/alergijas-un-nepanesibas/partikas-alergija-nav-modes-diagnoze-ta-ir-nopietna-veselibas-problema_en.json": [
		57258,
		57258
	],
	"./health-issues/alergijas-un-nepanesibas/partikas-alergija-nav-modes-diagnoze-ta-ir-nopietna-veselibas-problema_lv.json": [
		92626,
		92626
	],
	"./health-issues/alergijas-un-nepanesibas/partikas-alergija-nav-modes-diagnoze-ta-ir-nopietna-veselibas-problema_ru.json": [
		56150,
		56150
	],
	"./health-issues/alergijas-un-nepanesibas/pavasaris-acis-kapec-rodas-alergisks-konjunktivits-_en.json": [
		60649,
		60649
	],
	"./health-issues/alergijas-un-nepanesibas/pavasaris-acis-kapec-rodas-alergisks-konjunktivits-_lv.json": [
		14886,
		14886
	],
	"./health-issues/alergijas-un-nepanesibas/pavasaris-acis-kapec-rodas-alergisks-konjunktivits-_ru.json": [
		99899,
		99899
	],
	"./health-issues/alergijas-un-nepanesibas_en.json": [
		76154,
		76154
	],
	"./health-issues/alergijas-un-nepanesibas_lv.json": [
		64520,
		64520
	],
	"./health-issues/alergijas-un-nepanesibas_ru.json": [
		76183,
		76183
	],
	"./health-issues/alergisks-rinits-ka-dzivot-vieglak-alergijas-sezona-_en.json": [
		54310,
		54310
	],
	"./health-issues/alergisks-rinits-ka-dzivot-vieglak-alergijas-sezona-_lv.json": [
		99260,
		99260
	],
	"./health-issues/alergisks-rinits-ka-dzivot-vieglak-alergijas-sezona-_ru.json": [
		45161,
		45161
	],
	"./health-issues/alergisks-rinits_en.json": [
		17791,
		17791
	],
	"./health-issues/alergisks-rinits_lv.json": [
		62846,
		62846
	],
	"./health-issues/alergisks-rinits_ru.json": [
		12529,
		12529
	],
	"./health-issues/alopecija_en.json": [
		28205,
		28205
	],
	"./health-issues/alopecija_lv.json": [
		76087,
		76087
	],
	"./health-issues/alopecija_ru.json": [
		91745,
		91745
	],
	"./health-issues/angina_en.json": [
		32682,
		32682
	],
	"./health-issues/angina_lv.json": [
		36705,
		36705
	],
	"./health-issues/angina_ru.json": [
		19096,
		19096
	],
	"./health-issues/angiomas_en.json": [
		24328,
		24328
	],
	"./health-issues/angiomas_lv.json": [
		5564,
		5564
	],
	"./health-issues/angiomas_ru.json": [
		13613,
		13613
	],
	"./health-issues/aortas-aneirisma_en.json": [
		9382,
		9382
	],
	"./health-issues/aortas-aneirisma_lv.json": [
		4954,
		4954
	],
	"./health-issues/aortas-aneirisma_ru.json": [
		36379,
		36379
	],
	"./health-issues/aortas-disekcija_en.json": [
		23044,
		23044
	],
	"./health-issues/aortas-disekcija_lv.json": [
		70943,
		70943
	],
	"./health-issues/aortas-disekcija_ru.json": [
		74502,
		74502
	],
	"./health-issues/arpusdzemdes-grutnieciba-celoni-riski-un-atpazisana_en.json": [
		93143,
		93143
	],
	"./health-issues/arpusdzemdes-grutnieciba-celoni-riski-un-atpazisana_lv.json": [
		59118,
		59118
	],
	"./health-issues/arpusdzemdes-grutnieciba-celoni-riski-un-atpazisana_ru.json": [
		88767,
		88767
	],
	"./health-issues/asinis-urina_en.json": [
		83293,
		83293
	],
	"./health-issues/asinis-urina_lv.json": [
		45146,
		45146
	],
	"./health-issues/asinis-urina_ru.json": [
		54167,
		54167
	],
	"./health-issues/ateroskleroze_en.json": [
		17888,
		17888
	],
	"./health-issues/ateroskleroze_lv.json": [
		68140,
		68140
	],
	"./health-issues/ateroskleroze_ru.json": [
		25580,
		92458
	],
	"./health-issues/atopiskais-dermatits_en.json": [
		42291,
		42291
	],
	"./health-issues/atopiskais-dermatits_lv.json": [
		63285,
		63285
	],
	"./health-issues/atopiskais-dermatits_ru.json": [
		23124,
		23124
	],
	"./health-issues/ausis-deguns-un-kakls/_all_en.json": [
		88483,
		88483
	],
	"./health-issues/ausis-deguns-un-kakls/_all_lv.json": [
		10754,
		10754
	],
	"./health-issues/ausis-deguns-un-kakls/_all_ru.json": [
		34413,
		34413
	],
	"./health-issues/ausis-deguns-un-kakls/alergisks-rinits_en.json": [
		38471,
		38471
	],
	"./health-issues/ausis-deguns-un-kakls/alergisks-rinits_lv.json": [
		45120,
		45120
	],
	"./health-issues/ausis-deguns-un-kakls/alergisks-rinits_ru.json": [
		86506,
		86506
	],
	"./health-issues/ausis-deguns-un-kakls/angina_en.json": [
		14841,
		14841
	],
	"./health-issues/ausis-deguns-un-kakls/angina_lv.json": [
		33640,
		33640
	],
	"./health-issues/ausis-deguns-un-kakls/angina_ru.json": [
		42745,
		42745
	],
	"./health-issues/ausis-deguns-un-kakls/deguna-asinosana_en.json": [
		47594,
		47594
	],
	"./health-issues/ausis-deguns-un-kakls/deguna-asinosana_lv.json": [
		90550,
		90550
	],
	"./health-issues/ausis-deguns-un-kakls/deguna-asinosana_ru.json": [
		63063,
		63063
	],
	"./health-issues/ausis-deguns-un-kakls/faringits_en.json": [
		86542,
		86542
	],
	"./health-issues/ausis-deguns-un-kakls/faringits_lv.json": [
		35992,
		35992
	],
	"./health-issues/ausis-deguns-un-kakls/faringits_ru.json": [
		95752,
		95752
	],
	"./health-issues/ausis-deguns-un-kakls/klepus_en.json": [
		41306,
		41306
	],
	"./health-issues/ausis-deguns-un-kakls/klepus_lv.json": [
		35939,
		35939
	],
	"./health-issues/ausis-deguns-un-kakls/klepus_ru.json": [
		69536,
		69536
	],
	"./health-issues/ausis-deguns-un-kakls/laringits_en.json": [
		45551,
		45551
	],
	"./health-issues/ausis-deguns-un-kakls/laringits_lv.json": [
		11044,
		11044
	],
	"./health-issues/ausis-deguns-un-kakls/laringits_ru.json": [
		30291,
		30291
	],
	"./health-issues/ausis-deguns-un-kakls/sinusits_en.json": [
		12094,
		12094
	],
	"./health-issues/ausis-deguns-un-kakls/sinusits_lv.json": [
		57538,
		57538
	],
	"./health-issues/ausis-deguns-un-kakls/sinusits_ru.json": [
		65586,
		65586
	],
	"./health-issues/ausis-deguns-un-kakls_en.json": [
		28640,
		28640
	],
	"./health-issues/ausis-deguns-un-kakls_lv.json": [
		26067,
		26067
	],
	"./health-issues/ausis-deguns-un-kakls_ru.json": [
		89853,
		89853
	],
	"./health-issues/autoimunas-saslimsanas/_all_en.json": [
		50941,
		50941
	],
	"./health-issues/autoimunas-saslimsanas/_all_lv.json": [
		28787,
		28787
	],
	"./health-issues/autoimunas-saslimsanas/_all_ru.json": [
		83009,
		83009
	],
	"./health-issues/autoimunas-saslimsanas/celiakija_en.json": [
		6907,
		6907
	],
	"./health-issues/autoimunas-saslimsanas/celiakija_lv.json": [
		32169,
		32169
	],
	"./health-issues/autoimunas-saslimsanas/celiakija_ru.json": [
		93617,
		93617
	],
	"./health-issues/autoimunas-saslimsanas/cukura-diabets_en.json": [
		33788,
		33788
	],
	"./health-issues/autoimunas-saslimsanas/cukura-diabets_lv.json": [
		62273,
		62273
	],
	"./health-issues/autoimunas-saslimsanas/cukura-diabets_ru.json": [
		36694,
		36694
	],
	"./health-issues/autoimunas-saslimsanas/greivsa-slimiba_en.json": [
		43843,
		43843
	],
	"./health-issues/autoimunas-saslimsanas/greivsa-slimiba_lv.json": [
		41351,
		77618
	],
	"./health-issues/autoimunas-saslimsanas/greivsa-slimiba_ru.json": [
		78282,
		78282
	],
	"./health-issues/autoimunas-saslimsanas/hasimoto-slimiba-jeb-tireoidits_en.json": [
		93251,
		93251
	],
	"./health-issues/autoimunas-saslimsanas/hasimoto-slimiba-jeb-tireoidits_lv.json": [
		97582,
		97582
	],
	"./health-issues/autoimunas-saslimsanas/hasimoto-slimiba-jeb-tireoidits_ru.json": [
		81223,
		81223
	],
	"./health-issues/autoimunas-saslimsanas/lupus_en.json": [
		54163,
		54163
	],
	"./health-issues/autoimunas-saslimsanas/lupus_lv.json": [
		26858,
		26858
	],
	"./health-issues/autoimunas-saslimsanas/lupus_ru.json": [
		57508,
		57508
	],
	"./health-issues/autoimunas-saslimsanas/miastenija_en.json": [
		4540,
		4540
	],
	"./health-issues/autoimunas-saslimsanas/miastenija_lv.json": [
		2534,
		2534
	],
	"./health-issues/autoimunas-saslimsanas/miastenija_ru.json": [
		14134,
		14134
	],
	"./health-issues/autoimunas-saslimsanas/multipla-skleroze_en.json": [
		85660,
		85660
	],
	"./health-issues/autoimunas-saslimsanas/multipla-skleroze_lv.json": [
		81065,
		81065
	],
	"./health-issues/autoimunas-saslimsanas/multipla-skleroze_ru.json": [
		57347,
		57347
	],
	"./health-issues/autoimunas-saslimsanas/psoriaze_en.json": [
		9680,
		9680
	],
	"./health-issues/autoimunas-saslimsanas/psoriaze_lv.json": [
		71817,
		71817
	],
	"./health-issues/autoimunas-saslimsanas/psoriaze_ru.json": [
		87293,
		87293
	],
	"./health-issues/autoimunas-saslimsanas/reimatoidais-artrits_en.json": [
		41009,
		41009
	],
	"./health-issues/autoimunas-saslimsanas/reimatoidais-artrits_lv.json": [
		81744,
		81744
	],
	"./health-issues/autoimunas-saslimsanas/reimatoidais-artrits_ru.json": [
		38932,
		38932
	],
	"./health-issues/autoimunas-saslimsanas/segrena-sindroms_en.json": [
		92195,
		92195
	],
	"./health-issues/autoimunas-saslimsanas/segrena-sindroms_lv.json": [
		26871,
		26871
	],
	"./health-issues/autoimunas-saslimsanas/segrena-sindroms_ru.json": [
		64342,
		64342
	],
	"./health-issues/autoimunas-saslimsanas_en.json": [
		61949,
		61949
	],
	"./health-issues/autoimunas-saslimsanas_lv.json": [
		12505,
		12505
	],
	"./health-issues/autoimunas-saslimsanas_ru.json": [
		65014,
		65014
	],
	"./health-issues/bipolarie-traucejumi_en.json": [
		68837,
		68837
	],
	"./health-issues/bipolarie-traucejumi_lv.json": [
		31040,
		31040
	],
	"./health-issues/bipolarie-traucejumi_ru.json": [
		58610,
		58610
	],
	"./health-issues/bronhits_en.json": [
		9875,
		9875
	],
	"./health-issues/bronhits_lv.json": [
		79831,
		79831
	],
	"./health-issues/bronhits_ru.json": [
		24912,
		24912
	],
	"./health-issues/caureja-ko-tavs-kermenis-megina-pateikt-_en.json": [
		43016,
		43016
	],
	"./health-issues/caureja-ko-tavs-kermenis-megina-pateikt-_lv.json": [
		87874,
		87874
	],
	"./health-issues/caureja-ko-tavs-kermenis-megina-pateikt-_ru.json": [
		68761,
		68761
	],
	"./health-issues/caureja-slikta-dusa-un-sapes-vedera-ta-var-but-zarnu-infekcija_en.json": [
		88349,
		88349
	],
	"./health-issues/caureja-slikta-dusa-un-sapes-vedera-ta-var-but-zarnu-infekcija_lv.json": [
		31408,
		31408
	],
	"./health-issues/caureja-slikta-dusa-un-sapes-vedera-ta-var-but-zarnu-infekcija_ru.json": [
		89269,
		89269
	],
	"./health-issues/celiakija_en.json": [
		8601,
		8601
	],
	"./health-issues/celiakija_lv.json": [
		32547,
		32547
	],
	"./health-issues/celiakija_ru.json": [
		98954,
		98954
	],
	"./health-issues/cerebrala-trieka_en.json": [
		16714,
		16714
	],
	"./health-issues/cerebrala-trieka_lv.json": [
		38681,
		38681
	],
	"./health-issues/cerebrala-trieka_ru.json": [
		32813,
		96375
	],
	"./health-issues/cilveka-papilomas-viruss_en.json": [
		41737,
		41737
	],
	"./health-issues/cilveka-papilomas-viruss_lv.json": [
		55477,
		55477
	],
	"./health-issues/cilveka-papilomas-viruss_ru.json": [
		47153,
		47153
	],
	"./health-issues/cistiska-fibroze_en.json": [
		93081,
		93081
	],
	"./health-issues/cistiska-fibroze_lv.json": [
		96684,
		96684
	],
	"./health-issues/cistiska-fibroze_ru.json": [
		13564,
		13564
	],
	"./health-issues/cistits_en.json": [
		5266,
		5266
	],
	"./health-issues/cistits_lv.json": [
		86828,
		86828
	],
	"./health-issues/cistits_ru.json": [
		63242,
		63242
	],
	"./health-issues/covid-19_en.json": [
		32003,
		32003
	],
	"./health-issues/covid-19_lv.json": [
		17692,
		17692
	],
	"./health-issues/covid-19_ru.json": [
		12211,
		12211
	],
	"./health-issues/cukura-diabets-test_en.json": [
		44233,
		44233
	],
	"./health-issues/cukura-diabets-test_lv.json": [
		92560,
		92560
	],
	"./health-issues/cukura-diabets-test_ru.json": [
		2883,
		2883
	],
	"./health-issues/cukura-diabets_en.json": [
		66893,
		66893
	],
	"./health-issues/cukura-diabets_lv.json": [
		31724,
		31724
	],
	"./health-issues/cukura-diabets_ru.json": [
		47407,
		47407
	],
	"./health-issues/dedzinasana-aiz-krusu-kaula-uzzini-kas-ir-refluksa-ezofagits_en.json": [
		27366,
		27366
	],
	"./health-issues/dedzinasana-aiz-krusu-kaula-uzzini-kas-ir-refluksa-ezofagits_lv.json": [
		96855,
		96855
	],
	"./health-issues/dedzinasana-aiz-krusu-kaula-uzzini-kas-ir-refluksa-ezofagits_ru.json": [
		88397,
		88397
	],
	"./health-issues/deguna-asinosana_en.json": [
		41008,
		41008
	],
	"./health-issues/deguna-asinosana_lv.json": [
		26388,
		26388
	],
	"./health-issues/deguna-asinosana_ru.json": [
		18233,
		18233
	],
	"./health-issues/depresija-skumjas-vai-slimiba-kas-jauztver-nopietni-_en.json": [
		3146,
		3146
	],
	"./health-issues/depresija-skumjas-vai-slimiba-kas-jauztver-nopietni-_lv.json": [
		42236,
		42236
	],
	"./health-issues/depresija-skumjas-vai-slimiba-kas-jauztver-nopietni-_ru.json": [
		34259,
		34259
	],
	"./health-issues/depresija-skumjas-vai-slimiba-kas-jauztver-nopietni_en.json": [
		39226,
		39226
	],
	"./health-issues/depresija-skumjas-vai-slimiba-kas-jauztver-nopietni_lv.json": [
		93740,
		93740
	],
	"./health-issues/depresija-skumjas-vai-slimiba-kas-jauztver-nopietni_ru.json": [
		70960,
		70960
	],
	"./health-issues/dermatits_en.json": [
		12701,
		12701
	],
	"./health-issues/dermatits_lv.json": [
		29003,
		29003
	],
	"./health-issues/dermatits_ru.json": [
		18691,
		18691
	],
	"./health-issues/difterija_en.json": [
		99928,
		99928
	],
	"./health-issues/difterija_lv.json": [
		22294,
		22294
	],
	"./health-issues/difterija_ru.json": [
		83268,
		83268
	],
	"./health-issues/dulkains-urins_en.json": [
		47569,
		47569
	],
	"./health-issues/dulkains-urins_lv.json": [
		57064,
		57064
	],
	"./health-issues/dulkains-urins_ru.json": [
		39698,
		39698
	],
	"./health-issues/dzimumorganu-karpas-jeb-kondilomas-simptomi-celoni-un-risinajumi_en.json": [
		54810,
		54810
	],
	"./health-issues/dzimumorganu-karpas-jeb-kondilomas-simptomi-celoni-un-risinajumi_lv.json": [
		78584,
		78584
	],
	"./health-issues/dzimumorganu-karpas-jeb-kondilomas-simptomi-celoni-un-risinajumi_ru.json": [
		13662,
		13662
	],
	"./health-issues/ekzema_en.json": [
		2351,
		2351
	],
	"./health-issues/ekzema_lv.json": [
		32091,
		32091
	],
	"./health-issues/ekzema_ru.json": [
		88030,
		88030
	],
	"./health-issues/elposanas-sistema/_all_en.json": [
		86278,
		86278
	],
	"./health-issues/elposanas-sistema/_all_lv.json": [
		25112,
		25112
	],
	"./health-issues/elposanas-sistema/_all_ru.json": [
		87548,
		87548
	],
	"./health-issues/elposanas-sistema/alergisks-rinits_en.json": [
		42071,
		42071
	],
	"./health-issues/elposanas-sistema/alergisks-rinits_lv.json": [
		94160,
		94160
	],
	"./health-issues/elposanas-sistema/alergisks-rinits_ru.json": [
		22334,
		22334
	],
	"./health-issues/elposanas-sistema/bronhits_en.json": [
		4051,
		4051
	],
	"./health-issues/elposanas-sistema/bronhits_lv.json": [
		27897,
		27897
	],
	"./health-issues/elposanas-sistema/bronhits_ru.json": [
		35033,
		35033
	],
	"./health-issues/elposanas-sistema/cistiska-fibroze_en.json": [
		54703,
		54703
	],
	"./health-issues/elposanas-sistema/cistiska-fibroze_lv.json": [
		43411,
		43411
	],
	"./health-issues/elposanas-sistema/cistiska-fibroze_ru.json": [
		36924,
		36924
	],
	"./health-issues/elposanas-sistema/hops_en.json": [
		4881,
		4881
	],
	"./health-issues/elposanas-sistema/hops_lv.json": [
		72976,
		72976
	],
	"./health-issues/elposanas-sistema/hops_ru.json": [
		94306,
		94306
	],
	"./health-issues/elposanas-sistema/hronisks-sinusits_en.json": [
		6332,
		6332
	],
	"./health-issues/elposanas-sistema/hronisks-sinusits_lv.json": [
		53113,
		53113
	],
	"./health-issues/elposanas-sistema/hronisks-sinusits_ru.json": [
		24604,
		24604
	],
	"./health-issues/elposanas-sistema/plausu-fibroze_en.json": [
		64888,
		64888
	],
	"./health-issues/elposanas-sistema/plausu-fibroze_lv.json": [
		57818,
		57818
	],
	"./health-issues/elposanas-sistema/plausu-fibroze_ru.json": [
		42180,
		42180
	],
	"./health-issues/elposanas-sistema/pleirits_en.json": [
		93062,
		93062
	],
	"./health-issues/elposanas-sistema/pleirits_lv.json": [
		50683,
		50683
	],
	"./health-issues/elposanas-sistema/pleirits_ru.json": [
		75955,
		75955
	],
	"./health-issues/elposanas-sistema/pneimonija_en.json": [
		82247,
		82247
	],
	"./health-issues/elposanas-sistema/pneimonija_lv.json": [
		86747,
		86747
	],
	"./health-issues/elposanas-sistema/pneimonija_ru.json": [
		44178,
		44178
	],
	"./health-issues/elposanas-sistema/sauss-klepus_en.json": [
		45906,
		45906
	],
	"./health-issues/elposanas-sistema/sauss-klepus_lv.json": [
		27468,
		27468
	],
	"./health-issues/elposanas-sistema/sauss-klepus_ru.json": [
		72571,
		72571
	],
	"./health-issues/elposanas-sistema/tuberkoloze_en.json": [
		30052,
		30052
	],
	"./health-issues/elposanas-sistema/tuberkoloze_lv.json": [
		97452,
		87538
	],
	"./health-issues/elposanas-sistema/tuberkoloze_ru.json": [
		97012,
		97012
	],
	"./health-issues/elposanas-sistema_en.json": [
		68153,
		68153
	],
	"./health-issues/elposanas-sistema_lv.json": [
		84064,
		84064
	],
	"./health-issues/elposanas-sistema_ru.json": [
		36545,
		36545
	],
	"./health-issues/endokardits_en.json": [
		70139,
		70139
	],
	"./health-issues/endokardits_lv.json": [
		79419,
		79419
	],
	"./health-issues/endokardits_ru.json": [
		14472,
		14472
	],
	"./health-issues/epilepsija_en.json": [
		25586,
		25586
	],
	"./health-issues/epilepsija_lv.json": [
		2419,
		2419
	],
	"./health-issues/epilepsija_ru.json": [
		94261,
		94261
	],
	"./health-issues/ercu-encefalits_en.json": [
		14588,
		14588
	],
	"./health-issues/ercu-encefalits_lv.json": [
		42337,
		42337
	],
	"./health-issues/ercu-encefalits_ru.json": [
		49267,
		49267
	],
	"./health-issues/erekcijas-disfunkcija-celoni-simptomi-un-arstesanas-iespejas_en.json": [
		63535,
		63535
	],
	"./health-issues/erekcijas-disfunkcija-celoni-simptomi-un-arstesanas-iespejas_lv.json": [
		31905,
		31905
	],
	"./health-issues/erekcijas-disfunkcija-celoni-simptomi-un-arstesanas-iespejas_ru.json": [
		41544,
		41544
	],
	"./health-issues/esanas-traucejumi_en.json": [
		60355,
		60355
	],
	"./health-issues/esanas-traucejumi_lv.json": [
		98852,
		98852
	],
	"./health-issues/esanas-traucejumi_ru.json": [
		50209,
		50209
	],
	"./health-issues/faringits_en.json": [
		46346,
		46346
	],
	"./health-issues/faringits_lv.json": [
		50864,
		50864
	],
	"./health-issues/faringits_ru.json": [
		9217,
		9217
	],
	"./health-issues/galvassapes_en.json": [
		89157,
		89157
	],
	"./health-issues/galvassapes_lv.json": [
		50218,
		50218
	],
	"./health-issues/galvassapes_ru.json": [
		21395,
		21395
	],
	"./health-issues/gastrits_en.json": [
		78469,
		78469
	],
	"./health-issues/gastrits_lv.json": [
		15295,
		15295
	],
	"./health-issues/gastrits_ru.json": [
		1183,
		1183
	],
	"./health-issues/gonoreja_en.json": [
		47992,
		47992
	],
	"./health-issues/gonoreja_lv.json": [
		12731,
		12731
	],
	"./health-issues/gonoreja_ru.json": [
		63292,
		63292
	],
	"./health-issues/greivsa-slimiba_en.json": [
		6584,
		6584
	],
	"./health-issues/greivsa-slimiba_lv.json": [
		9972,
		9972
	],
	"./health-issues/greivsa-slimiba_ru.json": [
		71663,
		71663
	],
	"./health-issues/gremosanas-sistema/_all_en.json": [
		2038,
		2038
	],
	"./health-issues/gremosanas-sistema/_all_lv.json": [
		53332,
		53332
	],
	"./health-issues/gremosanas-sistema/_all_ru.json": [
		36750,
		36750
	],
	"./health-issues/gremosanas-sistema/aizcietejumi-neerta-bet-loti-izplatita-problema-ka-to-risinat-_en.json": [
		32574,
		32574
	],
	"./health-issues/gremosanas-sistema/aizcietejumi-neerta-bet-loti-izplatita-problema-ka-to-risinat-_lv.json": [
		81145,
		81145
	],
	"./health-issues/gremosanas-sistema/aizcietejumi-neerta-bet-loti-izplatita-problema-ka-to-risinat-_ru.json": [
		52892,
		52892
	],
	"./health-issues/gremosanas-sistema/aknu-ciroze_en.json": [
		41808,
		41808
	],
	"./health-issues/gremosanas-sistema/aknu-ciroze_lv.json": [
		39543,
		39543
	],
	"./health-issues/gremosanas-sistema/aknu-ciroze_ru.json": [
		29600,
		29600
	],
	"./health-issues/gremosanas-sistema/caureja-ko-tavs-kermenis-megina-pateikt-_en.json": [
		93110,
		93110
	],
	"./health-issues/gremosanas-sistema/caureja-ko-tavs-kermenis-megina-pateikt-_lv.json": [
		93055,
		93055
	],
	"./health-issues/gremosanas-sistema/caureja-ko-tavs-kermenis-megina-pateikt-_ru.json": [
		23933,
		23933
	],
	"./health-issues/gremosanas-sistema/caureja-slikta-dusa-un-sapes-vedera-ta-var-but-zarnu-infekcija_en.json": [
		8546,
		8546
	],
	"./health-issues/gremosanas-sistema/caureja-slikta-dusa-un-sapes-vedera-ta-var-but-zarnu-infekcija_lv.json": [
		53392,
		53392
	],
	"./health-issues/gremosanas-sistema/caureja-slikta-dusa-un-sapes-vedera-ta-var-but-zarnu-infekcija_ru.json": [
		87564,
		87564
	],
	"./health-issues/gremosanas-sistema/dedzinasana-aiz-krusu-kaula-uzzini-kas-ir-refluksa-ezofagits_en.json": [
		22804,
		22804
	],
	"./health-issues/gremosanas-sistema/dedzinasana-aiz-krusu-kaula-uzzini-kas-ir-refluksa-ezofagits_lv.json": [
		63236,
		63236
	],
	"./health-issues/gremosanas-sistema/dedzinasana-aiz-krusu-kaula-uzzini-kas-ir-refluksa-ezofagits_ru.json": [
		99473,
		99473
	],
	"./health-issues/gremosanas-sistema/gastrits_en.json": [
		35156,
		35156
	],
	"./health-issues/gremosanas-sistema/gastrits_lv.json": [
		3238,
		3238
	],
	"./health-issues/gremosanas-sistema/gastrits_ru.json": [
		68414,
		68414
	],
	"./health-issues/gremosanas-sistema/gremosanas-sistemas-traucejumi-kapec-tie-rodas-un-ko-darit-_en.json": [
		37256,
		37256
	],
	"./health-issues/gremosanas-sistema/gremosanas-sistemas-traucejumi-kapec-tie-rodas-un-ko-darit-_lv.json": [
		79104,
		79104
	],
	"./health-issues/gremosanas-sistema/gremosanas-sistemas-traucejumi-kapec-tie-rodas-un-ko-darit-_ru.json": [
		62180,
		62180
	],
	"./health-issues/gremosanas-sistema/koprostaze-smags-aizcietejums-ko-nedrikst-ignoret_en.json": [
		66772,
		66772
	],
	"./health-issues/gremosanas-sistema/koprostaze-smags-aizcietejums-ko-nedrikst-ignoret_lv.json": [
		98516,
		98516
	],
	"./health-issues/gremosanas-sistema/koprostaze-smags-aizcietejums-ko-nedrikst-ignoret_ru.json": [
		86408,
		86408
	],
	"./health-issues/gremosanas-sistema/kunga-cula_en.json": [
		30726,
		30726
	],
	"./health-issues/gremosanas-sistema/kunga-cula_lv.json": [
		50055,
		50055
	],
	"./health-issues/gremosanas-sistema/kunga-cula_ru.json": [
		60222,
		97452
	],
	"./health-issues/gremosanas-sistema/pankreatits_en.json": [
		56136,
		56136
	],
	"./health-issues/gremosanas-sistema/pankreatits_lv.json": [
		66179,
		66179
	],
	"./health-issues/gremosanas-sistema/pankreatits_ru.json": [
		21914,
		21914
	],
	"./health-issues/gremosanas-sistema/pastavigas-sapes-vedera-un-vedera-pusanas-tas-var-but-kairinatu-zarnu-sindroms-_en.json": [
		57687,
		57687
	],
	"./health-issues/gremosanas-sistema/pastavigas-sapes-vedera-un-vedera-pusanas-tas-var-but-kairinatu-zarnu-sindroms-_lv.json": [
		25345,
		25345
	],
	"./health-issues/gremosanas-sistema/pastavigas-sapes-vedera-un-vedera-pusanas-tas-var-but-kairinatu-zarnu-sindroms-_ru.json": [
		62184,
		62184
	],
	"./health-issues/gremosanas-sistema/piena-produkti-nesader-ar-tavu-kermeni-iemesls-var-but-laktozes-nepanesamiba_en.json": [
		80861,
		80861
	],
	"./health-issues/gremosanas-sistema/piena-produkti-nesader-ar-tavu-kermeni-iemesls-var-but-laktozes-nepanesamiba_lv.json": [
		54630,
		54630
	],
	"./health-issues/gremosanas-sistema/piena-produkti-nesader-ar-tavu-kermeni-iemesls-var-but-laktozes-nepanesamiba_ru.json": [
		10157,
		10157
	],
	"./health-issues/gremosanas-sistema/tava-aknu-veseliba-ka-saprast-hepatita-riskus-_en.json": [
		68884,
		68884
	],
	"./health-issues/gremosanas-sistema/tava-aknu-veseliba-ka-saprast-hepatita-riskus-_lv.json": [
		78082,
		78082
	],
	"./health-issues/gremosanas-sistema/tava-aknu-veseliba-ka-saprast-hepatita-riskus-_ru.json": [
		36616,
		36616
	],
	"./health-issues/gremosanas-sistema/zarnu-mikrobioma-lidzsvara-traucejumi-jeb-disbakterioze-ko-darit-_en.json": [
		42109,
		42109
	],
	"./health-issues/gremosanas-sistema/zarnu-mikrobioma-lidzsvara-traucejumi-jeb-disbakterioze-ko-darit-_lv.json": [
		56074,
		56074
	],
	"./health-issues/gremosanas-sistema/zarnu-mikrobioma-lidzsvara-traucejumi-jeb-disbakterioze-ko-darit-_ru.json": [
		43960,
		43960
	],
	"./health-issues/gremosanas-sistema/zarnu-polipi-agrins-signals-nopietnakam-veselibas-problemam-_en.json": [
		49263,
		49263
	],
	"./health-issues/gremosanas-sistema/zarnu-polipi-agrins-signals-nopietnakam-veselibas-problemam-_lv.json": [
		32059,
		32059
	],
	"./health-issues/gremosanas-sistema/zarnu-polipi-agrins-signals-nopietnakam-veselibas-problemam-_ru.json": [
		32399,
		32399
	],
	"./health-issues/gremosanas-sistema_en.json": [
		61537,
		61537
	],
	"./health-issues/gremosanas-sistema_lv.json": [
		9612,
		9612
	],
	"./health-issues/gremosanas-sistema_ru.json": [
		91793,
		91793
	],
	"./health-issues/gremosanas-sistemas-traucejumi-kapec-tie-rodas-un-ko-darit-_en.json": [
		1393,
		1393
	],
	"./health-issues/gremosanas-sistemas-traucejumi-kapec-tie-rodas-un-ko-darit-_lv.json": [
		89779,
		89779
	],
	"./health-issues/gremosanas-sistemas-traucejumi-kapec-tie-rodas-un-ko-darit-_ru.json": [
		88589,
		88589
	],
	"./health-issues/gripa_en.json": [
		5268,
		5268
	],
	"./health-issues/gripa_lv.json": [
		61003,
		61003
	],
	"./health-issues/gripa_ru.json": [
		48298,
		48298
	],
	"./health-issues/hasimoto-slimiba-jeb-tireoidits_en.json": [
		6214,
		6214
	],
	"./health-issues/hasimoto-slimiba-jeb-tireoidits_lv.json": [
		60474,
		60474
	],
	"./health-issues/hasimoto-slimiba-jeb-tireoidits_ru.json": [
		83640,
		83640
	],
	"./health-issues/hepatits_en.json": [
		23023,
		23023
	],
	"./health-issues/hepatits_lv.json": [
		87501,
		87501
	],
	"./health-issues/hepatits_ru.json": [
		70874,
		70874
	],
	"./health-issues/herpes_en.json": [
		5546,
		5546
	],
	"./health-issues/herpes_lv.json": [
		92344,
		92344
	],
	"./health-issues/herpes_ru.json": [
		24839,
		24839
	],
	"./health-issues/hidroenfroze_en.json": [
		10206,
		10206
	],
	"./health-issues/hidroenfroze_lv.json": [
		24637,
		24637
	],
	"./health-issues/hidroenfroze_ru.json": [
		94526,
		74709
	],
	"./health-issues/hipertensija_en.json": [
		20955,
		20955
	],
	"./health-issues/hipertensija_lv.json": [
		48757,
		48757
	],
	"./health-issues/hipertensija_ru.json": [
		19741,
		19741
	],
	"./health-issues/hipertireoze-jeb-vairogdziedzera-pastiprinata-darbiba_en.json": [
		99167,
		99167
	],
	"./health-issues/hipertireoze-jeb-vairogdziedzera-pastiprinata-darbiba_lv.json": [
		12420,
		12420
	],
	"./health-issues/hipertireoze-jeb-vairogdziedzera-pastiprinata-darbiba_ru.json": [
		44712,
		44712
	],
	"./health-issues/hipertireoze-vai-vairogdziedzera-pastiprinata-darbiba_en.json": [
		81245,
		81245
	],
	"./health-issues/hipertireoze-vai-vairogdziedzera-pastiprinata-darbiba_lv.json": [
		55846,
		55846
	],
	"./health-issues/hipertireoze-vai-vairogdziedzera-pastiprinata-darbiba_ru.json": [
		98250,
		98250
	],
	"./health-issues/hipotireoze-jeb-vairogdziedzera-nepietiekama-funkcija_en.json": [
		75179,
		75179
	],
	"./health-issues/hipotireoze-jeb-vairogdziedzera-nepietiekama-funkcija_lv.json": [
		24038,
		24038
	],
	"./health-issues/hipotireoze-jeb-vairogdziedzera-nepietiekama-funkcija_ru.json": [
		1761,
		1761
	],
	"./health-issues/hipotireoze-vairogdziedzera-nepietiekama-funkcija_en.json": [
		80817,
		80817
	],
	"./health-issues/hipotireoze-vairogdziedzera-nepietiekama-funkcija_lv.json": [
		9945,
		9945
	],
	"./health-issues/hipotireoze-vairogdziedzera-nepietiekama-funkcija_ru.json": [
		32168,
		32168
	],
	"./health-issues/hlamidija_en.json": [
		86227,
		86227
	],
	"./health-issues/hlamidija_lv.json": [
		30742,
		30742
	],
	"./health-issues/hlamidija_ru.json": [
		88329,
		88329
	],
	"./health-issues/hops_en.json": [
		6445,
		94526
	],
	"./health-issues/hops_lv.json": [
		58377,
		58377
	],
	"./health-issues/hops_ru.json": [
		92748,
		92748
	],
	"./health-issues/hormoni-endokrina-sistema/_all_en.json": [
		25794,
		25794
	],
	"./health-issues/hormoni-endokrina-sistema/_all_lv.json": [
		85584,
		85584
	],
	"./health-issues/hormoni-endokrina-sistema/_all_ru.json": [
		61890,
		61890
	],
	"./health-issues/hormoni-endokrina-sistema/adenoma_en.json": [
		27189,
		27189
	],
	"./health-issues/hormoni-endokrina-sistema/adenoma_lv.json": [
		94651,
		94651
	],
	"./health-issues/hormoni-endokrina-sistema/adenoma_ru.json": [
		21108,
		21108
	],
	"./health-issues/hormoni-endokrina-sistema/adisona-slimiba_en.json": [
		36568,
		36568
	],
	"./health-issues/hormoni-endokrina-sistema/adisona-slimiba_lv.json": [
		61371,
		61371
	],
	"./health-issues/hormoni-endokrina-sistema/adisona-slimiba_ru.json": [
		41049,
		41049
	],
	"./health-issues/hormoni-endokrina-sistema/cukura-diabets_en.json": [
		99611,
		99611
	],
	"./health-issues/hormoni-endokrina-sistema/cukura-diabets_lv.json": [
		37324,
		37324
	],
	"./health-issues/hormoni-endokrina-sistema/cukura-diabets_ru.json": [
		83099,
		83099
	],
	"./health-issues/hormoni-endokrina-sistema/greivsa-slimiba_en.json": [
		54878,
		54878
	],
	"./health-issues/hormoni-endokrina-sistema/greivsa-slimiba_lv.json": [
		20021,
		20021
	],
	"./health-issues/hormoni-endokrina-sistema/greivsa-slimiba_ru.json": [
		78160,
		78160
	],
	"./health-issues/hormoni-endokrina-sistema/hasimoto-slimiba-jeb-tireoidits_en.json": [
		52203,
		52203
	],
	"./health-issues/hormoni-endokrina-sistema/hasimoto-slimiba-jeb-tireoidits_lv.json": [
		21712,
		21712
	],
	"./health-issues/hormoni-endokrina-sistema/hasimoto-slimiba-jeb-tireoidits_ru.json": [
		62644,
		62644
	],
	"./health-issues/hormoni-endokrina-sistema/hipertireoze-jeb-vairogdziedzera-pastiprinata-darbiba_en.json": [
		59522,
		59522
	],
	"./health-issues/hormoni-endokrina-sistema/hipertireoze-jeb-vairogdziedzera-pastiprinata-darbiba_lv.json": [
		4207,
		4207
	],
	"./health-issues/hormoni-endokrina-sistema/hipertireoze-jeb-vairogdziedzera-pastiprinata-darbiba_ru.json": [
		70586,
		70586
	],
	"./health-issues/hormoni-endokrina-sistema/hipotireoze-jeb-vairogdziedzera-nepietiekama-funkcija_en.json": [
		74364,
		74364
	],
	"./health-issues/hormoni-endokrina-sistema/hipotireoze-jeb-vairogdziedzera-nepietiekama-funkcija_lv.json": [
		10253,
		10253
	],
	"./health-issues/hormoni-endokrina-sistema/hipotireoze-jeb-vairogdziedzera-nepietiekama-funkcija_ru.json": [
		96516,
		96516
	],
	"./health-issues/hormoni-endokrina-sistema/kusinga-sindroms_en.json": [
		85897,
		85897
	],
	"./health-issues/hormoni-endokrina-sistema/kusinga-sindroms_lv.json": [
		60476,
		60476
	],
	"./health-issues/hormoni-endokrina-sistema/kusinga-sindroms_ru.json": [
		14108,
		14108
	],
	"./health-issues/hormoni-endokrina-sistema_en.json": [
		44033,
		44033
	],
	"./health-issues/hormoni-endokrina-sistema_lv.json": [
		37927,
		37927
	],
	"./health-issues/hormoni-endokrina-sistema_ru.json": [
		74909,
		19749
	],
	"./health-issues/hronisks-sinusits_en.json": [
		69821,
		69821
	],
	"./health-issues/hronisks-sinusits_lv.json": [
		71261,
		71261
	],
	"./health-issues/hronisks-sinusits_ru.json": [
		66075,
		66075
	],
	"./health-issues/impetigo_en.json": [
		55789,
		55789
	],
	"./health-issues/impetigo_lv.json": [
		59400,
		59400
	],
	"./health-issues/impetigo_ru.json": [
		97807,
		97807
	],
	"./health-issues/infekcijas-slimibas/_all_en.json": [
		33815,
		33815
	],
	"./health-issues/infekcijas-slimibas/_all_lv.json": [
		34867,
		34867
	],
	"./health-issues/infekcijas-slimibas/_all_ru.json": [
		1778,
		1778
	],
	"./health-issues/infekcijas-slimibas/covid-19_en.json": [
		67509,
		67509
	],
	"./health-issues/infekcijas-slimibas/covid-19_lv.json": [
		21683,
		21683
	],
	"./health-issues/infekcijas-slimibas/covid-19_ru.json": [
		25253,
		25253
	],
	"./health-issues/infekcijas-slimibas/difterija_en.json": [
		49624,
		49624
	],
	"./health-issues/infekcijas-slimibas/difterija_lv.json": [
		13548,
		13548
	],
	"./health-issues/infekcijas-slimibas/difterija_ru.json": [
		24013,
		24013
	],
	"./health-issues/infekcijas-slimibas/ercu-encefalits_en.json": [
		75486,
		75486
	],
	"./health-issues/infekcijas-slimibas/ercu-encefalits_lv.json": [
		10914,
		10914
	],
	"./health-issues/infekcijas-slimibas/ercu-encefalits_ru.json": [
		30021,
		30021
	],
	"./health-issues/infekcijas-slimibas/gripa_en.json": [
		76348,
		76348
	],
	"./health-issues/infekcijas-slimibas/gripa_lv.json": [
		71970,
		71970
	],
	"./health-issues/infekcijas-slimibas/gripa_ru.json": [
		89504,
		89504
	],
	"./health-issues/infekcijas-slimibas/hepatits_en.json": [
		73079,
		73079
	],
	"./health-issues/infekcijas-slimibas/hepatits_lv.json": [
		66764,
		66764
	],
	"./health-issues/infekcijas-slimibas/hepatits_ru.json": [
		50982,
		50982
	],
	"./health-issues/infekcijas-slimibas/laima-slimiba_en.json": [
		44398,
		44398
	],
	"./health-issues/infekcijas-slimibas/laima-slimiba_lv.json": [
		78917,
		78917
	],
	"./health-issues/infekcijas-slimibas/laima-slimiba_ru.json": [
		46828,
		46828
	],
	"./health-issues/infekcijas-slimibas/malarija_en.json": [
		42689,
		42689
	],
	"./health-issues/infekcijas-slimibas/malarija_lv.json": [
		9278,
		9278
	],
	"./health-issues/infekcijas-slimibas/malarija_ru.json": [
		61845,
		61845
	],
	"./health-issues/infekcijas-slimibas/salmoneloze_en.json": [
		30335,
		30335
	],
	"./health-issues/infekcijas-slimibas/salmoneloze_lv.json": [
		70284,
		70284
	],
	"./health-issues/infekcijas-slimibas/salmoneloze_ru.json": [
		76902,
		76902
	],
	"./health-issues/infekcijas-slimibas/skarlatina_en.json": [
		1735,
		1735
	],
	"./health-issues/infekcijas-slimibas/skarlatina_lv.json": [
		49001,
		49001
	],
	"./health-issues/infekcijas-slimibas/skarlatina_ru.json": [
		50770,
		50770
	],
	"./health-issues/infekcijas-slimibas/tuberkuloze_en.json": [
		49151,
		49151
	],
	"./health-issues/infekcijas-slimibas/tuberkuloze_lv.json": [
		19335,
		19335
	],
	"./health-issues/infekcijas-slimibas/tuberkuloze_ru.json": [
		75764,
		75764
	],
	"./health-issues/infekcijas-slimibas/vejbakas_en.json": [
		78430,
		78430
	],
	"./health-issues/infekcijas-slimibas/vejbakas_lv.json": [
		7490,
		7490
	],
	"./health-issues/infekcijas-slimibas/vejbakas_ru.json": [
		93060,
		93060
	],
	"./health-issues/infekcijas-slimibas_en.json": [
		30756,
		30756
	],
	"./health-issues/infekcijas-slimibas_lv.json": [
		8789,
		8789
	],
	"./health-issues/infekcijas-slimibas_ru.json": [
		30230,
		30230
	],
	"./health-issues/kad-intimais-diskomforts-trauce-ikdienai-pievers-uzmanibu-vaginitam_en.json": [
		28580,
		28580
	],
	"./health-issues/kad-intimais-diskomforts-trauce-ikdienai-pievers-uzmanibu-vaginitam_lv.json": [
		54802,
		54802
	],
	"./health-issues/kad-intimais-diskomforts-trauce-ikdienai-pievers-uzmanibu-vaginitam_ru.json": [
		94120,
		94120
	],
	"./health-issues/kad-menstrualas-sapes-nav-normalas-kas-ir-endometrioze_en.json": [
		91686,
		91686
	],
	"./health-issues/kad-menstrualas-sapes-nav-normalas-kas-ir-endometrioze_lv.json": [
		22052,
		22052
	],
	"./health-issues/kad-menstrualas-sapes-nav-normalas-kas-ir-endometrioze_ru.json": [
		42031,
		42031
	],
	"./health-issues/kad-zarnu-darbiba-signalize-ko-nopietnu-izproti-zarnu-veza-pazimes_en.json": [
		4434,
		4434
	],
	"./health-issues/kad-zarnu-darbiba-signalize-ko-nopietnu-izproti-zarnu-veza-pazimes_lv.json": [
		39982,
		39982
	],
	"./health-issues/kad-zarnu-darbiba-signalize-ko-nopietnu-izproti-zarnu-veza-pazimes_ru.json": [
		65283,
		65283
	],
	"./health-issues/kaju-senite_en.json": [
		69094,
		69094
	],
	"./health-issues/kaju-senite_lv.json": [
		4922,
		4922
	],
	"./health-issues/kaju-senite_ru.json": [
		57781,
		57781
	],
	"./health-issues/kardiomiopatija_en.json": [
		51779,
		51779
	],
	"./health-issues/kardiomiopatija_lv.json": [
		54645,
		54645
	],
	"./health-issues/kardiomiopatija_ru.json": [
		64242,
		64242
	],
	"./health-issues/kardiovaskulara-sistema/_all_en.json": [
		94738,
		94738
	],
	"./health-issues/kardiovaskulara-sistema/_all_lv.json": [
		4756,
		4756
	],
	"./health-issues/kardiovaskulara-sistema/_all_ru.json": [
		27609,
		27609
	],
	"./health-issues/kardiovaskulara-sistema/aortas-aneirisma_en.json": [
		68534,
		68534
	],
	"./health-issues/kardiovaskulara-sistema/aortas-aneirisma_lv.json": [
		62348,
		62348
	],
	"./health-issues/kardiovaskulara-sistema/aortas-aneirisma_ru.json": [
		83537,
		83537
	],
	"./health-issues/kardiovaskulara-sistema/aortas-disekcija_en.json": [
		36431,
		36431
	],
	"./health-issues/kardiovaskulara-sistema/aortas-disekcija_lv.json": [
		89347,
		89347
	],
	"./health-issues/kardiovaskulara-sistema/aortas-disekcija_ru.json": [
		5863,
		5863
	],
	"./health-issues/kardiovaskulara-sistema/ateroskleroze_en.json": [
		86259,
		86259
	],
	"./health-issues/kardiovaskulara-sistema/ateroskleroze_lv.json": [
		45657,
		45657
	],
	"./health-issues/kardiovaskulara-sistema/ateroskleroze_ru.json": [
		78859,
		78859
	],
	"./health-issues/kardiovaskulara-sistema/endokardits_en.json": [
		76309,
		76309
	],
	"./health-issues/kardiovaskulara-sistema/endokardits_lv.json": [
		18064,
		18064
	],
	"./health-issues/kardiovaskulara-sistema/endokardits_ru.json": [
		91296,
		91296
	],
	"./health-issues/kardiovaskulara-sistema/hipertensija_en.json": [
		61764,
		61764
	],
	"./health-issues/kardiovaskulara-sistema/hipertensija_lv.json": [
		65618,
		65618
	],
	"./health-issues/kardiovaskulara-sistema/hipertensija_ru.json": [
		2691,
		2691
	],
	"./health-issues/kardiovaskulara-sistema/kardiomiopatija_en.json": [
		46571,
		46571
	],
	"./health-issues/kardiovaskulara-sistema/kardiomiopatija_lv.json": [
		97921,
		97921
	],
	"./health-issues/kardiovaskulara-sistema/kardiomiopatija_ru.json": [
		22625,
		22625
	],
	"./health-issues/kardiovaskulara-sistema/koronara-sirds-slimiba_en.json": [
		10580,
		10580
	],
	"./health-issues/kardiovaskulara-sistema/koronara-sirds-slimiba_lv.json": [
		14217,
		14217
	],
	"./health-issues/kardiovaskulara-sistema/koronara-sirds-slimiba_ru.json": [
		24060,
		24060
	],
	"./health-issues/kardiovaskulara-sistema/marfana-sindroms_en.json": [
		10318,
		10318
	],
	"./health-issues/kardiovaskulara-sistema/marfana-sindroms_lv.json": [
		26193,
		26193
	],
	"./health-issues/kardiovaskulara-sistema/marfana-sindroms_ru.json": [
		48207,
		48207
	],
	"./health-issues/kardiovaskulara-sistema/metaboliskais-sindroms_en.json": [
		20573,
		20573
	],
	"./health-issues/kardiovaskulara-sistema/metaboliskais-sindroms_lv.json": [
		91701,
		91701
	],
	"./health-issues/kardiovaskulara-sistema/metaboliskais-sindroms_ru.json": [
		97513,
		97513
	],
	"./health-issues/kardiovaskulara-sistema/miokarda-infarkts_en.json": [
		58396,
		58396
	],
	"./health-issues/kardiovaskulara-sistema/miokarda-infarkts_lv.json": [
		71998,
		71998
	],
	"./health-issues/kardiovaskulara-sistema/miokarda-infarkts_ru.json": [
		71284,
		71284
	],
	"./health-issues/kardiovaskulara-sistema/miokardits_en.json": [
		41726,
		41726
	],
	"./health-issues/kardiovaskulara-sistema/miokardits_lv.json": [
		80577,
		80577
	],
	"./health-issues/kardiovaskulara-sistema/miokardits_ru.json": [
		74248,
		74248
	],
	"./health-issues/kardiovaskulara-sistema/perikardits_en.json": [
		28229,
		28229
	],
	"./health-issues/kardiovaskulara-sistema/perikardits_lv.json": [
		60962,
		60962
	],
	"./health-issues/kardiovaskulara-sistema/perikardits_ru.json": [
		16063,
		16063
	],
	"./health-issues/kardiovaskulara-sistema/sinusa-tahikardija_en.json": [
		42604,
		42604
	],
	"./health-issues/kardiovaskulara-sistema/sinusa-tahikardija_lv.json": [
		37986,
		37986
	],
	"./health-issues/kardiovaskulara-sistema/sinusa-tahikardija_ru.json": [
		20790,
		20790
	],
	"./health-issues/kardiovaskulara-sistema/sirds-aritmija_en.json": [
		89685,
		89685
	],
	"./health-issues/kardiovaskulara-sistema/sirds-aritmija_lv.json": [
		14831,
		14831
	],
	"./health-issues/kardiovaskulara-sistema/sirds-aritmija_ru.json": [
		59552,
		59552
	],
	"./health-issues/kardiovaskulara-sistema/sirds-mazspeja_en.json": [
		50329,
		50329
	],
	"./health-issues/kardiovaskulara-sistema/sirds-mazspeja_lv.json": [
		99686,
		99686
	],
	"./health-issues/kardiovaskulara-sistema/sirds-mazspeja_ru.json": [
		87068,
		87068
	],
	"./health-issues/kardiovaskulara-sistema/tahikardija-kad-sirds-sitas-parak-atri_en.json": [
		31502,
		31502
	],
	"./health-issues/kardiovaskulara-sistema/tahikardija-kad-sirds-sitas-parak-atri_lv.json": [
		67437,
		67437
	],
	"./health-issues/kardiovaskulara-sistema/tahikardija-kad-sirds-sitas-parak-atri_ru.json": [
		88113,
		88113
	],
	"./health-issues/kardiovaskulara-sistema_en.json": [
		76058,
		76058
	],
	"./health-issues/kardiovaskulara-sistema_lv.json": [
		21696,
		21696
	],
	"./health-issues/kardiovaskulara-sistema_ru.json": [
		23828,
		23828
	],
	"./health-issues/karpas_en.json": [
		81690,
		81690
	],
	"./health-issues/karpas_lv.json": [
		60454,
		60454
	],
	"./health-issues/karpas_ru.json": [
		3818,
		3818
	],
	"./health-issues/kas-jazina-par-abortu-mediciniski-un-emocionali-aspekti_en.json": [
		4193,
		4193
	],
	"./health-issues/kas-jazina-par-abortu-mediciniski-un-emocionali-aspekti_lv.json": [
		26897,
		26897
	],
	"./health-issues/kas-jazina-par-abortu-mediciniski-un-emocionali-aspekti_ru.json": [
		64860,
		64860
	],
	"./health-issues/kaskis_en.json": [
		38814,
		38814
	],
	"./health-issues/kaskis_lv.json": [
		98369,
		98369
	],
	"./health-issues/kaskis_ru.json": [
		27019,
		27019
	],
	"./health-issues/klepus_en.json": [
		68859,
		68859
	],
	"./health-issues/klepus_lv.json": [
		45093,
		45093
	],
	"./health-issues/klepus_ru.json": [
		6382,
		6382
	],
	"./health-issues/ko-tu-nezinaji-par-herpes-virusu-_en.json": [
		5457,
		5457
	],
	"./health-issues/ko-tu-nezinaji-par-herpes-virusu-_lv.json": [
		86367,
		86367
	],
	"./health-issues/ko-tu-nezinaji-par-herpes-virusu-_ru.json": [
		38577,
		38577
	],
	"./health-issues/koksaki-viruss_en.json": [
		19162,
		19162
	],
	"./health-issues/koksaki-viruss_lv.json": [
		12728,
		12728
	],
	"./health-issues/koksaki-viruss_ru.json": [
		20373,
		20373
	],
	"./health-issues/koprostaze-smags-aizcietejums-ko-nedrikst-ignoret_en.json": [
		80028,
		80028
	],
	"./health-issues/koprostaze-smags-aizcietejums-ko-nedrikst-ignoret_lv.json": [
		27153,
		27153
	],
	"./health-issues/koprostaze-smags-aizcietejums-ko-nedrikst-ignoret_ru.json": [
		27751,
		27751
	],
	"./health-issues/koronara-sirds-slimiba_en.json": [
		41775,
		41775
	],
	"./health-issues/koronara-sirds-slimiba_lv.json": [
		59531,
		59531
	],
	"./health-issues/koronara-sirds-slimiba_ru.json": [
		81091,
		81091
	],
	"./health-issues/kunga-cula_en.json": [
		25899,
		25899
	],
	"./health-issues/kunga-cula_lv.json": [
		16260,
		16260
	],
	"./health-issues/kunga-cula_ru.json": [
		8079,
		8079
	],
	"./health-issues/kunga-vezis-simptomi-kurus-nedrikst-ignoret_en.json": [
		99578,
		99578
	],
	"./health-issues/kunga-vezis-simptomi-kurus-nedrikst-ignoret_lv.json": [
		29320,
		29320
	],
	"./health-issues/kunga-vezis-simptomi-kurus-nedrikst-ignoret_ru.json": [
		71071,
		71071
	],
	"./health-issues/kusinga-sindroms_en.json": [
		73873,
		73873
	],
	"./health-issues/kusinga-sindroms_lv.json": [
		13772,
		13772
	],
	"./health-issues/kusinga-sindroms_ru.json": [
		64284,
		64284
	],
	"./health-issues/laima-slimiba_en.json": [
		57932,
		57932
	],
	"./health-issues/laima-slimiba_lv.json": [
		78037,
		78037
	],
	"./health-issues/laima-slimiba_ru.json": [
		15183,
		15183
	],
	"./health-issues/laringits_en.json": [
		53891,
		53891
	],
	"./health-issues/laringits_lv.json": [
		37249,
		37249
	],
	"./health-issues/laringits_ru.json": [
		93642,
		93642
	],
	"./health-issues/leikemija-ka-laikus-atpazit-un-kur-meklet-palidzibu_en.json": [
		5226,
		5226
	],
	"./health-issues/leikemija-ka-laikus-atpazit-un-kur-meklet-palidzibu_lv.json": [
		20067,
		20067
	],
	"./health-issues/leikemija-ka-laikus-atpazit-un-kur-meklet-palidzibu_ru.json": [
		21295,
		21295
	],
	"./health-issues/lupus_en.json": [
		60389,
		60389
	],
	"./health-issues/lupus_lv.json": [
		38178,
		38178
	],
	"./health-issues/lupus_ru.json": [
		28869,
		28869
	],
	"./health-issues/malarija_en.json": [
		88115,
		88115
	],
	"./health-issues/malarija_lv.json": [
		66604,
		66604
	],
	"./health-issues/malarija_ru.json": [
		70378,
		70378
	],
	"./health-issues/marfana-sindroms_en.json": [
		54056,
		54056
	],
	"./health-issues/marfana-sindroms_lv.json": [
		76115,
		76115
	],
	"./health-issues/marfana-sindroms_ru.json": [
		20500,
		20500
	],
	"./health-issues/melanoma_en.json": [
		39029,
		39029
	],
	"./health-issues/melanoma_lv.json": [
		36688,
		36688
	],
	"./health-issues/melanoma_ru.json": [
		94221,
		94221
	],
	"./health-issues/menesreizes-viss-kas-jazina-par-menstrualo-ciklu_en.json": [
		57262,
		57262
	],
	"./health-issues/menesreizes-viss-kas-jazina-par-menstrualo-ciklu_lv.json": [
		14427,
		14427
	],
	"./health-issues/menesreizes-viss-kas-jazina-par-menstrualo-ciklu_ru.json": [
		73044,
		73044
	],
	"./health-issues/meningits_en.json": [
		44466,
		44466
	],
	"./health-issues/meningits_lv.json": [
		45332,
		45332
	],
	"./health-issues/meningits_ru.json": [
		52650,
		52650
	],
	"./health-issues/metaboliskais-sindroms_en.json": [
		87639,
		87639
	],
	"./health-issues/metaboliskais-sindroms_lv.json": [
		54907,
		54907
	],
	"./health-issues/metaboliskais-sindroms_ru.json": [
		49704,
		49704
	],
	"./health-issues/miastenija_en.json": [
		15447,
		15447
	],
	"./health-issues/miastenija_lv.json": [
		1680,
		1680
	],
	"./health-issues/miastenija_ru.json": [
		59167,
		59167
	],
	"./health-issues/migrena_en.json": [
		77362,
		77362
	],
	"./health-issues/migrena_lv.json": [
		46817,
		46817
	],
	"./health-issues/migrena_ru.json": [
		41867,
		41867
	],
	"./health-issues/miokarda-infarkts_en.json": [
		89061,
		89061
	],
	"./health-issues/miokarda-infarkts_lv.json": [
		644,
		644
	],
	"./health-issues/miokarda-infarkts_ru.json": [
		98634,
		98634
	],
	"./health-issues/miokardits_en.json": [
		30423,
		30423
	],
	"./health-issues/miokardits_lv.json": [
		11393,
		11393
	],
	"./health-issues/miokardits_ru.json": [
		49209,
		49209
	],
	"./health-issues/multipla-skleroze_en.json": [
		22978,
		22978
	],
	"./health-issues/multipla-skleroze_lv.json": [
		68952,
		68952
	],
	"./health-issues/multipla-skleroze_ru.json": [
		49630,
		49630
	],
	"./health-issues/muskuloskeletala-sistema_en.json": [
		72894,
		72894
	],
	"./health-issues/muskuloskeletala-sistema_lv.json": [
		80619,
		80619
	],
	"./health-issues/muskuloskeletala-sistema_ru.json": [
		58061,
		58061
	],
	"./health-issues/nagu-senite_en.json": [
		83389,
		83389
	],
	"./health-issues/nagu-senite_lv.json": [
		50305,
		50305
	],
	"./health-issues/nagu-senite_ru.json": [
		56628,
		56628
	],
	"./health-issues/neirologiskas-saslimsanas/_all_en.json": [
		45893,
		45893
	],
	"./health-issues/neirologiskas-saslimsanas/_all_lv.json": [
		71060,
		71060
	],
	"./health-issues/neirologiskas-saslimsanas/_all_ru.json": [
		2393,
		2393
	],
	"./health-issues/neirologiskas-saslimsanas/alcheimera-slimiba_en.json": [
		37755,
		37755
	],
	"./health-issues/neirologiskas-saslimsanas/alcheimera-slimiba_lv.json": [
		32624,
		32624
	],
	"./health-issues/neirologiskas-saslimsanas/alcheimera-slimiba_ru.json": [
		57166,
		57166
	],
	"./health-issues/neirologiskas-saslimsanas/cerebrala-trieka_en.json": [
		18680,
		18680
	],
	"./health-issues/neirologiskas-saslimsanas/cerebrala-trieka_lv.json": [
		46216,
		46216
	],
	"./health-issues/neirologiskas-saslimsanas/cerebrala-trieka_ru.json": [
		9688,
		9688
	],
	"./health-issues/neirologiskas-saslimsanas/epilepsija_en.json": [
		1734,
		1734
	],
	"./health-issues/neirologiskas-saslimsanas/epilepsija_lv.json": [
		44914,
		44914
	],
	"./health-issues/neirologiskas-saslimsanas/epilepsija_ru.json": [
		5744,
		5744
	],
	"./health-issues/neirologiskas-saslimsanas/galvassapes_en.json": [
		15954,
		15954
	],
	"./health-issues/neirologiskas-saslimsanas/galvassapes_lv.json": [
		93623,
		93623
	],
	"./health-issues/neirologiskas-saslimsanas/galvassapes_ru.json": [
		34937,
		34937
	],
	"./health-issues/neirologiskas-saslimsanas/meningits_en.json": [
		9398,
		9398
	],
	"./health-issues/neirologiskas-saslimsanas/meningits_lv.json": [
		52890,
		52890
	],
	"./health-issues/neirologiskas-saslimsanas/meningits_ru.json": [
		9284,
		9284
	],
	"./health-issues/neirologiskas-saslimsanas/migrena_en.json": [
		25019,
		25019
	],
	"./health-issues/neirologiskas-saslimsanas/migrena_lv.json": [
		48203,
		48203
	],
	"./health-issues/neirologiskas-saslimsanas/migrena_ru.json": [
		98012,
		98012
	],
	"./health-issues/neirologiskas-saslimsanas/multipla-skleroze_en.json": [
		56557,
		56557
	],
	"./health-issues/neirologiskas-saslimsanas/multipla-skleroze_lv.json": [
		34786,
		34786
	],
	"./health-issues/neirologiskas-saslimsanas/multipla-skleroze_ru.json": [
		4856,
		4856
	],
	"./health-issues/neirologiskas-saslimsanas/parkinsona-slimiba_en.json": [
		50399,
		50399
	],
	"./health-issues/neirologiskas-saslimsanas/parkinsona-slimiba_lv.json": [
		49679,
		49679
	],
	"./health-issues/neirologiskas-saslimsanas/parkinsona-slimiba_ru.json": [
		47609,
		47609
	],
	"./health-issues/neirologiskas-saslimsanas/smadzenu-insults_en.json": [
		3259,
		3259
	],
	"./health-issues/neirologiskas-saslimsanas/smadzenu-insults_lv.json": [
		15165,
		15165
	],
	"./health-issues/neirologiskas-saslimsanas/smadzenu-insults_ru.json": [
		29449,
		29449
	],
	"./health-issues/neirologiskas-saslimsanas/smadzenu-satricinajums_en.json": [
		6577,
		6577
	],
	"./health-issues/neirologiskas-saslimsanas/smadzenu-satricinajums_lv.json": [
		21544,
		21544
	],
	"./health-issues/neirologiskas-saslimsanas/smadzenu-satricinajums_ru.json": [
		74971,
		74971
	],
	"./health-issues/neirologiskas-saslimsanas_en.json": [
		59272,
		59272
	],
	"./health-issues/neirologiskas-saslimsanas_lv.json": [
		30772,
		30772
	],
	"./health-issues/neirologiskas-saslimsanas_ru.json": [
		83248,
		83248
	],
	"./health-issues/neraksturigi-simptomi-pec-ediena-iespejams-vainigs-ir-histamins_en.json": [
		38528,
		38528
	],
	"./health-issues/neraksturigi-simptomi-pec-ediena-iespejams-vainigs-ir-histamins_lv.json": [
		71329,
		71329
	],
	"./health-issues/neraksturigi-simptomi-pec-ediena-iespejams-vainigs-ir-histamins_ru.json": [
		30792,
		30792
	],
	"./health-issues/nierakmeni_en.json": [
		33894,
		33894
	],
	"./health-issues/nierakmeni_lv.json": [
		46281,
		46281
	],
	"./health-issues/nierakmeni_ru.json": [
		1770,
		1770
	],
	"./health-issues/nieru-mazspeja_en.json": [
		57414,
		57414
	],
	"./health-issues/nieru-mazspeja_lv.json": [
		52716,
		52716
	],
	"./health-issues/nieru-mazspeja_ru.json": [
		86086,
		86086
	],
	"./health-issues/nieru-slimibas_en.json": [
		26246,
		26246
	],
	"./health-issues/nieru-slimibas_lv.json": [
		58551,
		58551
	],
	"./health-issues/nieru-slimibas_ru.json": [
		80709,
		80709
	],
	"./health-issues/nieze-izsitumi-un-apsartums-vai-ta-ir-adas-alergija-_en.json": [
		26101,
		26101
	],
	"./health-issues/nieze-izsitumi-un-apsartums-vai-ta-ir-adas-alergija-_lv.json": [
		60428,
		60428
	],
	"./health-issues/nieze-izsitumi-un-apsartums-vai-ta-ir-adas-alergija-_ru.json": [
		19032,
		19032
	],
	"./health-issues/no-dzimumzimes-lidz-diagnozei-patiesiba-par-melanomu_en.json": [
		69906,
		69906
	],
	"./health-issues/no-dzimumzimes-lidz-diagnozei-patiesiba-par-melanomu_lv.json": [
		68589,
		68589
	],
	"./health-issues/no-dzimumzimes-lidz-diagnozei-patiesiba-par-melanomu_ru.json": [
		94340,
		94340
	],
	"./health-issues/no-garastavokla-mainam-lidz-sapem-viss-par-pms_en.json": [
		93690,
		93690
	],
	"./health-issues/no-garastavokla-mainam-lidz-sapem-viss-par-pms_lv.json": [
		71717,
		71717
	],
	"./health-issues/no-garastavokla-mainam-lidz-sapem-viss-par-pms_ru.json": [
		74842,
		74842
	],
	"./health-issues/no-karstuma-vilniem-lidz-bezmiegam-viss-par-menopauzi_en.json": [
		20888,
		20888
	],
	"./health-issues/no-karstuma-vilniem-lidz-bezmiegam-viss-par-menopauzi_lv.json": [
		26727,
		26727
	],
	"./health-issues/no-karstuma-vilniem-lidz-bezmiegam-viss-par-menopauzi_ru.json": [
		42813,
		42813
	],
	"./health-issues/no-niezes-lidz-infekcijai-ka-atpazit-viriesu-dzimumorganu-slimibas_en.json": [
		8508,
		8508
	],
	"./health-issues/no-niezes-lidz-infekcijai-ka-atpazit-viriesu-dzimumorganu-slimibas_lv.json": [
		36796,
		36796
	],
	"./health-issues/no-niezes-lidz-infekcijai-ka-atpazit-viriesu-dzimumorganu-slimibas_ru.json": [
		91502,
		91502
	],
	"./health-issues/no-pavasara-prieka-uz-deguna-ciesanam-vai-tev-ir-siena-drudzis_en.json": [
		31176,
		31176
	],
	"./health-issues/no-pavasara-prieka-uz-deguna-ciesanam-vai-tev-ir-siena-drudzis_lv.json": [
		69543,
		69543
	],
	"./health-issues/no-pavasara-prieka-uz-deguna-ciesanam-vai-tev-ir-siena-drudzis_ru.json": [
		52109,
		52109
	],
	"./health-issues/no-vedera-pusanas-lidz-nogurumam-partikas-nepanesamibas-simptomi_en.json": [
		41711,
		41711
	],
	"./health-issues/no-vedera-pusanas-lidz-nogurumam-partikas-nepanesamibas-simptomi_lv.json": [
		19252,
		19252
	],
	"./health-issues/no-vedera-pusanas-lidz-nogurumam-partikas-nepanesamibas-simptomi_ru.json": [
		9973,
		9973
	],
	"./health-issues/nogurums-svara-pieaugums-aukstuma-sajuta-ta-var-but-hipotireoze_en.json": [
		88633,
		88633
	],
	"./health-issues/nogurums-svara-pieaugums-aukstuma-sajuta-ta-var-but-hipotireoze_lv.json": [
		86336,
		86336
	],
	"./health-issues/nogurums-svara-pieaugums-aukstuma-sajuta-ta-var-but-hipotireoze_ru.json": [
		42182,
		42182
	],
	"./health-issues/obsesivi-kompulsivi-traucejumi_en.json": [
		63622,
		63622
	],
	"./health-issues/obsesivi-kompulsivi-traucejumi_lv.json": [
		97145,
		97145
	],
	"./health-issues/obsesivi-kompulsivi-traucejumi_ru.json": [
		42785,
		42785
	],
	"./health-issues/ovulacija-un-augliba-viss-kas-tev-jazina_en.json": [
		67403,
		67403
	],
	"./health-issues/ovulacija-un-augliba-viss-kas-tev-jazina_lv.json": [
		2971,
		2971
	],
	"./health-issues/ovulacija-un-augliba-viss-kas-tev-jazina_ru.json": [
		71009,
		71009
	],
	"./health-issues/paaugstinats-cukura-limenis-grutniecibas-laika-kas-ir-gestacijas-diabets-_en.json": [
		48673,
		48673
	],
	"./health-issues/paaugstinats-cukura-limenis-grutniecibas-laika-kas-ir-gestacijas-diabets-_lv.json": [
		73644,
		73644
	],
	"./health-issues/paaugstinats-cukura-limenis-grutniecibas-laika-kas-ir-gestacijas-diabets-_ru.json": [
		36767,
		36767
	],
	"./health-issues/panikas-lekmes_en.json": [
		76946,
		76946
	],
	"./health-issues/panikas-lekmes_lv.json": [
		21038,
		21038
	],
	"./health-issues/panikas-lekmes_ru.json": [
		60341,
		60341
	],
	"./health-issues/pankreatits_en.json": [
		99696,
		99696
	],
	"./health-issues/pankreatits_lv.json": [
		44143,
		44143
	],
	"./health-issues/pankreatits_ru.json": [
		12663,
		12663
	],
	"./health-issues/parbaudi-savu-adu-adas-vezis-var-sakties-nemanami_en.json": [
		60243,
		60243
	],
	"./health-issues/parbaudi-savu-adu-adas-vezis-var-sakties-nemanami_lv.json": [
		77382,
		77382
	],
	"./health-issues/parbaudi-savu-adu-adas-vezis-var-sakties-nemanami_ru.json": [
		30969,
		30969
	],
	"./health-issues/parkinsona-slimiba_en.json": [
		3659,
		3659
	],
	"./health-issues/parkinsona-slimiba_lv.json": [
		92559,
		92559
	],
	"./health-issues/parkinsona-slimiba_ru.json": [
		68421,
		68421
	],
	"./health-issues/partikas-alergija-nav-modes-diagnoze-ta-ir-nopietna-veselibas-problema_en.json": [
		43243,
		43243
	],
	"./health-issues/partikas-alergija-nav-modes-diagnoze-ta-ir-nopietna-veselibas-problema_lv.json": [
		73614,
		73614
	],
	"./health-issues/partikas-alergija-nav-modes-diagnoze-ta-ir-nopietna-veselibas-problema_ru.json": [
		79756,
		79756
	],
	"./health-issues/pastavigas-sapes-vedera-un-vedera-pusanas-tas-var-but-kairinatu-zarnu-sindroms-_en.json": [
		55434,
		55434
	],
	"./health-issues/pastavigas-sapes-vedera-un-vedera-pusanas-tas-var-but-kairinatu-zarnu-sindroms-_lv.json": [
		6816,
		6816
	],
	"./health-issues/pastavigas-sapes-vedera-un-vedera-pusanas-tas-var-but-kairinatu-zarnu-sindroms-_ru.json": [
		98870,
		98870
	],
	"./health-issues/pavasaris-acis-kapec-rodas-alergisks-konjunktivits-_en.json": [
		29045,
		29045
	],
	"./health-issues/pavasaris-acis-kapec-rodas-alergisks-konjunktivits-_lv.json": [
		32762,
		32762
	],
	"./health-issues/pavasaris-acis-kapec-rodas-alergisks-konjunktivits-_ru.json": [
		31575,
		31575
	],
	"./health-issues/pecdzemdibu-depresija-ka-to-atpazit-un-kur-meklet-palidzibu_en.json": [
		41710,
		41710
	],
	"./health-issues/pecdzemdibu-depresija-ka-to-atpazit-un-kur-meklet-palidzibu_lv.json": [
		37631,
		37631
	],
	"./health-issues/pecdzemdibu-depresija-ka-to-atpazit-un-kur-meklet-palidzibu_ru.json": [
		10312,
		10312
	],
	"./health-issues/pectraumatiska-stresa-traucejumi-ptst_en.json": [
		41192,
		41192
	],
	"./health-issues/pectraumatiska-stresa-traucejumi-ptst_lv.json": [
		50232,
		50232
	],
	"./health-issues/pectraumatiska-stresa-traucejumi-ptst_ru.json": [
		51554,
		51554
	],
	"./health-issues/perikardits_en.json": [
		52803,
		52803
	],
	"./health-issues/perikardits_lv.json": [
		98568,
		98568
	],
	"./health-issues/perikardits_ru.json": [
		69315,
		69315
	],
	"./health-issues/pielonefrits_en.json": [
		13002,
		13002
	],
	"./health-issues/pielonefrits_lv.json": [
		37388,
		37388
	],
	"./health-issues/pielonefrits_ru.json": [
		14494,
		14494
	],
	"./health-issues/piena-produkti-nesader-ar-tavu-kermeni-iemesls-var-but-laktozes-nepanesamiba_en.json": [
		96837,
		96837
	],
	"./health-issues/piena-produkti-nesader-ar-tavu-kermeni-iemesls-var-but-laktozes-nepanesamiba_lv.json": [
		12718,
		12718
	],
	"./health-issues/piena-produkti-nesader-ar-tavu-kermeni-iemesls-var-but-laktozes-nepanesamiba_ru.json": [
		25660,
		25660
	],
	"./health-issues/piodermija_en.json": [
		99506,
		99506
	],
	"./health-issues/piodermija_lv.json": [
		70683,
		70683
	],
	"./health-issues/piodermija_ru.json": [
		22640,
		22640
	],
	"./health-issues/plausu-fibroze_en.json": [
		14966,
		14966
	],
	"./health-issues/plausu-fibroze_lv.json": [
		72443,
		72443
	],
	"./health-issues/plausu-fibroze_ru.json": [
		2267,
		2267
	],
	"./health-issues/pleirits_en.json": [
		54618,
		54618
	],
	"./health-issues/pleirits_lv.json": [
		102,
		102
	],
	"./health-issues/pleirits_ru.json": [
		53909,
		53909
	],
	"./health-issues/pneimonija_en.json": [
		29769,
		29769
	],
	"./health-issues/pneimonija_lv.json": [
		43311,
		43311
	],
	"./health-issues/pneimonija_ru.json": [
		3711,
		3711
	],
	"./health-issues/policistisko-olnicu-sindroms-ka-to-atpazit-un-ka-ar-to-sadzivot_en.json": [
		71353,
		71353
	],
	"./health-issues/policistisko-olnicu-sindroms-ka-to-atpazit-un-ka-ar-to-sadzivot_lv.json": [
		88111,
		88111
	],
	"./health-issues/policistisko-olnicu-sindroms-ka-to-atpazit-un-ka-ar-to-sadzivot_ru.json": [
		86382,
		86382
	],
	"./health-issues/priapisms_en.json": [
		25039,
		25039
	],
	"./health-issues/priapisms_lv.json": [
		60864,
		60864
	],
	"./health-issues/priapisms_ru.json": [
		6803,
		6803
	],
	"./health-issues/prostatas-hiperplazija_en.json": [
		57183,
		57183
	],
	"./health-issues/prostatas-hiperplazija_lv.json": [
		39872,
		39872
	],
	"./health-issues/prostatas-hiperplazija_ru.json": [
		51785,
		51785
	],
	"./health-issues/prostatas-iekaisums_en.json": [
		99627,
		99627
	],
	"./health-issues/prostatas-iekaisums_lv.json": [
		12912,
		12912
	],
	"./health-issues/prostatas-iekaisums_ru.json": [
		43578,
		43578
	],
	"./health-issues/prostatits_en.json": [
		85366,
		85366
	],
	"./health-issues/prostatits_lv.json": [
		27486,
		27486
	],
	"./health-issues/prostatits_ru.json": [
		80981,
		80981
	],
	"./health-issues/psihiskas-veselibas-problemas/_all_en.json": [
		54066,
		54066
	],
	"./health-issues/psihiskas-veselibas-problemas/_all_lv.json": [
		67892,
		67892
	],
	"./health-issues/psihiskas-veselibas-problemas/_all_ru.json": [
		66402,
		66402
	],
	"./health-issues/psihiskas-veselibas-problemas/bipolarie-traucejumi_en.json": [
		63490,
		63490
	],
	"./health-issues/psihiskas-veselibas-problemas/bipolarie-traucejumi_lv.json": [
		12152,
		12152
	],
	"./health-issues/psihiskas-veselibas-problemas/bipolarie-traucejumi_ru.json": [
		87018,
		46059
	],
	"./health-issues/psihiskas-veselibas-problemas/depresija-skumjas-vai-slimiba-kas-jauztver-nopietni-_en.json": [
		69874,
		69874
	],
	"./health-issues/psihiskas-veselibas-problemas/depresija-skumjas-vai-slimiba-kas-jauztver-nopietni-_lv.json": [
		28448,
		28448
	],
	"./health-issues/psihiskas-veselibas-problemas/depresija-skumjas-vai-slimiba-kas-jauztver-nopietni-_ru.json": [
		57552,
		57552
	],
	"./health-issues/psihiskas-veselibas-problemas/depresija-skumjas-vai-slimiba-kas-jauztver-nopietni_en.json": [
		69991,
		69991
	],
	"./health-issues/psihiskas-veselibas-problemas/depresija-skumjas-vai-slimiba-kas-jauztver-nopietni_lv.json": [
		99064,
		99064
	],
	"./health-issues/psihiskas-veselibas-problemas/depresija-skumjas-vai-slimiba-kas-jauztver-nopietni_ru.json": [
		51805,
		51805
	],
	"./health-issues/psihiskas-veselibas-problemas/esanas-traucejumi_en.json": [
		21739,
		21739
	],
	"./health-issues/psihiskas-veselibas-problemas/esanas-traucejumi_lv.json": [
		66535,
		66535
	],
	"./health-issues/psihiskas-veselibas-problemas/esanas-traucejumi_ru.json": [
		6100,
		6100
	],
	"./health-issues/psihiskas-veselibas-problemas/obsesivi-kompulsivi-traucejumi_en.json": [
		43211,
		43211
	],
	"./health-issues/psihiskas-veselibas-problemas/obsesivi-kompulsivi-traucejumi_lv.json": [
		67688,
		67688
	],
	"./health-issues/psihiskas-veselibas-problemas/obsesivi-kompulsivi-traucejumi_ru.json": [
		98041,
		98041
	],
	"./health-issues/psihiskas-veselibas-problemas/panikas-lekmes_en.json": [
		72462,
		72462
	],
	"./health-issues/psihiskas-veselibas-problemas/panikas-lekmes_lv.json": [
		54139,
		54139
	],
	"./health-issues/psihiskas-veselibas-problemas/panikas-lekmes_ru.json": [
		18340,
		18340
	],
	"./health-issues/psihiskas-veselibas-problemas/pectraumatiska-stresa-traucejumi-ptst_en.json": [
		67959,
		67959
	],
	"./health-issues/psihiskas-veselibas-problemas/pectraumatiska-stresa-traucejumi-ptst_lv.json": [
		60362,
		60362
	],
	"./health-issues/psihiskas-veselibas-problemas/pectraumatiska-stresa-traucejumi-ptst_ru.json": [
		93806,
		93806
	],
	"./health-issues/psihiskas-veselibas-problemas/sociala-trauksme_en.json": [
		94717,
		94717
	],
	"./health-issues/psihiskas-veselibas-problemas/sociala-trauksme_lv.json": [
		84901,
		84901
	],
	"./health-issues/psihiskas-veselibas-problemas/sociala-trauksme_ru.json": [
		36112,
		36112
	],
	"./health-issues/psihiskas-veselibas-problemas/trauksme_en.json": [
		46104,
		46104
	],
	"./health-issues/psihiskas-veselibas-problemas/trauksme_lv.json": [
		60191,
		60191
	],
	"./health-issues/psihiskas-veselibas-problemas/trauksme_ru.json": [
		74952,
		74952
	],
	"./health-issues/psihiskas-veselibas-problemas_en.json": [
		37380,
		37380
	],
	"./health-issues/psihiskas-veselibas-problemas_lv.json": [
		31592,
		31592
	],
	"./health-issues/psihiskas-veselibas-problemas_ru.json": [
		79868,
		79868
	],
	"./health-issues/psoriaze_en.json": [
		80703,
		80703
	],
	"./health-issues/psoriaze_lv.json": [
		1224,
		1224
	],
	"./health-issues/psoriaze_ru.json": [
		77381,
		77381
	],
	"./health-issues/reimatoidais-artrits_en.json": [
		4253,
		4253
	],
	"./health-issues/reimatoidais-artrits_lv.json": [
		72562,
		72562
	],
	"./health-issues/reimatoidais-artrits_ru.json": [
		68321,
		68321
	],
	"./health-issues/reproduktiva-sistema/_all_en.json": [
		86111,
		86111
	],
	"./health-issues/reproduktiva-sistema/_all_lv.json": [
		35282,
		35282
	],
	"./health-issues/reproduktiva-sistema/_all_ru.json": [
		41965,
		41965
	],
	"./health-issues/reproduktiva-sistema/arpusdzemdes-grutnieciba-celoni-riski-un-atpazisana_en.json": [
		37477,
		37477
	],
	"./health-issues/reproduktiva-sistema/arpusdzemdes-grutnieciba-celoni-riski-un-atpazisana_lv.json": [
		63408,
		63408
	],
	"./health-issues/reproduktiva-sistema/arpusdzemdes-grutnieciba-celoni-riski-un-atpazisana_ru.json": [
		19600,
		19600
	],
	"./health-issues/reproduktiva-sistema/kad-intimais-diskomforts-trauce-ikdienai-pievers-uzmanibu-vaginitam_en.json": [
		36880,
		36880
	],
	"./health-issues/reproduktiva-sistema/kad-intimais-diskomforts-trauce-ikdienai-pievers-uzmanibu-vaginitam_lv.json": [
		95341,
		95341
	],
	"./health-issues/reproduktiva-sistema/kad-intimais-diskomforts-trauce-ikdienai-pievers-uzmanibu-vaginitam_ru.json": [
		66613,
		66613
	],
	"./health-issues/reproduktiva-sistema/kad-menstrualas-sapes-nav-normalas-kas-ir-endometrioze_en.json": [
		43604,
		43604
	],
	"./health-issues/reproduktiva-sistema/kad-menstrualas-sapes-nav-normalas-kas-ir-endometrioze_lv.json": [
		43194,
		43194
	],
	"./health-issues/reproduktiva-sistema/kad-menstrualas-sapes-nav-normalas-kas-ir-endometrioze_ru.json": [
		96996,
		96996
	],
	"./health-issues/reproduktiva-sistema/kas-jazina-par-abortu-mediciniski-un-emocionali-aspekti_en.json": [
		65893,
		65893
	],
	"./health-issues/reproduktiva-sistema/kas-jazina-par-abortu-mediciniski-un-emocionali-aspekti_lv.json": [
		58562,
		58562
	],
	"./health-issues/reproduktiva-sistema/kas-jazina-par-abortu-mediciniski-un-emocionali-aspekti_ru.json": [
		25542,
		25542
	],
	"./health-issues/reproduktiva-sistema/menesreizes-viss-kas-jazina-par-menstrualo-ciklu_en.json": [
		3883,
		3883
	],
	"./health-issues/reproduktiva-sistema/menesreizes-viss-kas-jazina-par-menstrualo-ciklu_lv.json": [
		13976,
		13976
	],
	"./health-issues/reproduktiva-sistema/menesreizes-viss-kas-jazina-par-menstrualo-ciklu_ru.json": [
		43240,
		43240
	],
	"./health-issues/reproduktiva-sistema/no-garastavokla-mainam-lidz-sapem-viss-par-pms_en.json": [
		45884,
		45884
	],
	"./health-issues/reproduktiva-sistema/no-garastavokla-mainam-lidz-sapem-viss-par-pms_lv.json": [
		54522,
		54522
	],
	"./health-issues/reproduktiva-sistema/no-garastavokla-mainam-lidz-sapem-viss-par-pms_ru.json": [
		78096,
		78096
	],
	"./health-issues/reproduktiva-sistema/no-karstuma-vilniem-lidz-bezmiegam-viss-par-menopauzi_en.json": [
		7973,
		7973
	],
	"./health-issues/reproduktiva-sistema/no-karstuma-vilniem-lidz-bezmiegam-viss-par-menopauzi_lv.json": [
		75271,
		75271
	],
	"./health-issues/reproduktiva-sistema/no-karstuma-vilniem-lidz-bezmiegam-viss-par-menopauzi_ru.json": [
		58511,
		58511
	],
	"./health-issues/reproduktiva-sistema/nogurums-svara-pieaugums-aukstuma-sajuta-ta-var-but-hipotireoze_en.json": [
		28419,
		28419
	],
	"./health-issues/reproduktiva-sistema/nogurums-svara-pieaugums-aukstuma-sajuta-ta-var-but-hipotireoze_lv.json": [
		48973,
		48973
	],
	"./health-issues/reproduktiva-sistema/nogurums-svara-pieaugums-aukstuma-sajuta-ta-var-but-hipotireoze_ru.json": [
		1509,
		1509
	],
	"./health-issues/reproduktiva-sistema/ovulacija-un-augliba-viss-kas-tev-jazina_en.json": [
		99972,
		99972
	],
	"./health-issues/reproduktiva-sistema/ovulacija-un-augliba-viss-kas-tev-jazina_lv.json": [
		61961,
		61961
	],
	"./health-issues/reproduktiva-sistema/ovulacija-un-augliba-viss-kas-tev-jazina_ru.json": [
		32018,
		32018
	],
	"./health-issues/reproduktiva-sistema/paaugstinats-cukura-limenis-grutniecibas-laika-kas-ir-gestacijas-diabets-_en.json": [
		15418,
		15418
	],
	"./health-issues/reproduktiva-sistema/paaugstinats-cukura-limenis-grutniecibas-laika-kas-ir-gestacijas-diabets-_lv.json": [
		71285,
		71285
	],
	"./health-issues/reproduktiva-sistema/paaugstinats-cukura-limenis-grutniecibas-laika-kas-ir-gestacijas-diabets-_ru.json": [
		44037,
		44037
	],
	"./health-issues/reproduktiva-sistema/pecdzemdibu-depresija-ka-to-atpazit-un-kur-meklet-palidzibu_en.json": [
		45219,
		45219
	],
	"./health-issues/reproduktiva-sistema/pecdzemdibu-depresija-ka-to-atpazit-un-kur-meklet-palidzibu_lv.json": [
		46595,
		46595
	],
	"./health-issues/reproduktiva-sistema/pecdzemdibu-depresija-ka-to-atpazit-un-kur-meklet-palidzibu_ru.json": [
		63647,
		63647
	],
	"./health-issues/reproduktiva-sistema/policistisko-olnicu-sindroms-ka-to-atpazit-un-ka-ar-to-sadzivot_en.json": [
		63555,
		63555
	],
	"./health-issues/reproduktiva-sistema/policistisko-olnicu-sindroms-ka-to-atpazit-un-ka-ar-to-sadzivot_lv.json": [
		4657,
		4657
	],
	"./health-issues/reproduktiva-sistema/policistisko-olnicu-sindroms-ka-to-atpazit-un-ka-ar-to-sadzivot_ru.json": [
		79928,
		79928
	],
	"./health-issues/reproduktiva-sistema_en.json": [
		95027,
		95027
	],
	"./health-issues/reproduktiva-sistema_lv.json": [
		43679,
		43679
	],
	"./health-issues/reproduktiva-sistema_ru.json": [
		62029,
		62029
	],
	"./health-issues/rozacija_en.json": [
		81932,
		81932
	],
	"./health-issues/rozacija_lv.json": [
		10180,
		10180
	],
	"./health-issues/rozacija_ru.json": [
		20678,
		20678
	],
	"./health-issues/salmoneloze_en.json": [
		47563,
		47563
	],
	"./health-issues/salmoneloze_lv.json": [
		23254,
		23254
	],
	"./health-issues/salmoneloze_ru.json": [
		10074,
		10074
	],
	"./health-issues/sauss-klepus_en.json": [
		346,
		346
	],
	"./health-issues/sauss-klepus_lv.json": [
		28984,
		28984
	],
	"./health-issues/sauss-klepus_ru.json": [
		65466,
		65466
	],
	"./health-issues/seborejiskais-dermatits_en.json": [
		4557,
		4557
	],
	"./health-issues/seborejiskais-dermatits_lv.json": [
		6061,
		6061
	],
	"./health-issues/seborejiskais-dermatits_ru.json": [
		90157,
		90157
	],
	"./health-issues/segrena-sindroms_en.json": [
		48495,
		48495
	],
	"./health-issues/segrena-sindroms_lv.json": [
		39447,
		39447
	],
	"./health-issues/segrena-sindroms_ru.json": [
		90631,
		90631
	],
	"./health-issues/seksuala-veseliba/_all_en.json": [
		90182,
		90182
	],
	"./health-issues/seksuala-veseliba/_all_lv.json": [
		70269,
		70269
	],
	"./health-issues/seksuala-veseliba/_all_ru.json": [
		93201,
		60907
	],
	"./health-issues/seksuala-veseliba/aids_en.json": [
		7392,
		7392
	],
	"./health-issues/seksuala-veseliba/aids_lv.json": [
		14780,
		14780
	],
	"./health-issues/seksuala-veseliba/aids_ru.json": [
		11155,
		11155
	],
	"./health-issues/seksuala-veseliba/cilveka-papilomas-viruss_en.json": [
		2673,
		2673
	],
	"./health-issues/seksuala-veseliba/cilveka-papilomas-viruss_lv.json": [
		87566,
		87566
	],
	"./health-issues/seksuala-veseliba/cilveka-papilomas-viruss_ru.json": [
		96339,
		96339
	],
	"./health-issues/seksuala-veseliba/dzimumorganu-karpas-jeb-kondilomas-simptomi-celoni-un-risinajumi_en.json": [
		84965,
		84965
	],
	"./health-issues/seksuala-veseliba/dzimumorganu-karpas-jeb-kondilomas-simptomi-celoni-un-risinajumi_lv.json": [
		16484,
		16484
	],
	"./health-issues/seksuala-veseliba/dzimumorganu-karpas-jeb-kondilomas-simptomi-celoni-un-risinajumi_ru.json": [
		54028,
		54028
	],
	"./health-issues/seksuala-veseliba/erekcijas-disfunkcija-celoni-simptomi-un-arstesanas-iespejas_en.json": [
		51369,
		51369
	],
	"./health-issues/seksuala-veseliba/erekcijas-disfunkcija-celoni-simptomi-un-arstesanas-iespejas_lv.json": [
		14662,
		14662
	],
	"./health-issues/seksuala-veseliba/erekcijas-disfunkcija-celoni-simptomi-un-arstesanas-iespejas_ru.json": [
		41643,
		41643
	],
	"./health-issues/seksuala-veseliba/gonoreja_en.json": [
		87759,
		87759
	],
	"./health-issues/seksuala-veseliba/gonoreja_lv.json": [
		66696,
		66696
	],
	"./health-issues/seksuala-veseliba/gonoreja_ru.json": [
		9475,
		9475
	],
	"./health-issues/seksuala-veseliba/hlamidija_en.json": [
		95381,
		95381
	],
	"./health-issues/seksuala-veseliba/hlamidija_lv.json": [
		37254,
		37254
	],
	"./health-issues/seksuala-veseliba/hlamidija_ru.json": [
		8768,
		8768
	],
	"./health-issues/seksuala-veseliba/ko-tu-nezinaji-par-herpes-virusu-_en.json": [
		39656,
		39656
	],
	"./health-issues/seksuala-veseliba/ko-tu-nezinaji-par-herpes-virusu-_lv.json": [
		44082,
		44082
	],
	"./health-issues/seksuala-veseliba/ko-tu-nezinaji-par-herpes-virusu-_ru.json": [
		30773,
		30773
	],
	"./health-issues/seksuala-veseliba/no-niezes-lidz-infekcijai-ka-atpazit-viriesu-dzimumorganu-slimibas_en.json": [
		21464,
		21464
	],
	"./health-issues/seksuala-veseliba/no-niezes-lidz-infekcijai-ka-atpazit-viriesu-dzimumorganu-slimibas_lv.json": [
		75402,
		75402
	],
	"./health-issues/seksuala-veseliba/no-niezes-lidz-infekcijai-ka-atpazit-viriesu-dzimumorganu-slimibas_ru.json": [
		76355,
		51189
	],
	"./health-issues/seksuala-veseliba/seksuali-transmisivas-slimibas_en.json": [
		37498,
		37498
	],
	"./health-issues/seksuala-veseliba/seksuali-transmisivas-slimibas_lv.json": [
		47957,
		47957
	],
	"./health-issues/seksuala-veseliba/seksuali-transmisivas-slimibas_ru.json": [
		5234,
		5234
	],
	"./health-issues/seksuala-veseliba/sifiliss_en.json": [
		97592,
		97592
	],
	"./health-issues/seksuala-veseliba/sifiliss_lv.json": [
		70288,
		70288
	],
	"./health-issues/seksuala-veseliba/sifiliss_ru.json": [
		86710,
		86710
	],
	"./health-issues/seksuala-veseliba/viss-kas-jazina-par-seksu-menesreizu-laika_en.json": [
		12643,
		12643
	],
	"./health-issues/seksuala-veseliba/viss-kas-jazina-par-seksu-menesreizu-laika_lv.json": [
		83988,
		83988
	],
	"./health-issues/seksuala-veseliba/viss-kas-jazina-par-seksu-menesreizu-laika_ru.json": [
		69714,
		69714
	],
	"./health-issues/seksuala-veseliba_en.json": [
		39915,
		39915
	],
	"./health-issues/seksuala-veseliba_lv.json": [
		97339,
		97339
	],
	"./health-issues/seksuala-veseliba_ru.json": [
		77947,
		77947
	],
	"./health-issues/seksuali-transmisivas-slimibas-sts-/aids_en.json": [
		16978,
		16978
	],
	"./health-issues/seksuali-transmisivas-slimibas-sts-/aids_lv.json": [
		56140,
		56140
	],
	"./health-issues/seksuali-transmisivas-slimibas-sts-/aids_ru.json": [
		95041,
		95041
	],
	"./health-issues/seksuali-transmisivas-slimibas-sts-/cilveka-papilomas-viruss_en.json": [
		4983,
		4983
	],
	"./health-issues/seksuali-transmisivas-slimibas-sts-/cilveka-papilomas-viruss_lv.json": [
		62064,
		62064
	],
	"./health-issues/seksuali-transmisivas-slimibas-sts-/cilveka-papilomas-viruss_ru.json": [
		57786,
		57786
	],
	"./health-issues/seksuali-transmisivas-slimibas-sts-/gonoreja_en.json": [
		97889,
		97889
	],
	"./health-issues/seksuali-transmisivas-slimibas-sts-/gonoreja_lv.json": [
		57072,
		57072
	],
	"./health-issues/seksuali-transmisivas-slimibas-sts-/gonoreja_ru.json": [
		10623,
		10623
	],
	"./health-issues/seksuali-transmisivas-slimibas-sts-/hlamidija_en.json": [
		905,
		905
	],
	"./health-issues/seksuali-transmisivas-slimibas-sts-/hlamidija_lv.json": [
		39753,
		39753
	],
	"./health-issues/seksuali-transmisivas-slimibas-sts-/hlamidija_ru.json": [
		54299,
		54299
	],
	"./health-issues/seksuali-transmisivas-slimibas-sts-/seksuali-transmisivas-slimibas_en.json": [
		59062,
		59062
	],
	"./health-issues/seksuali-transmisivas-slimibas-sts-/seksuali-transmisivas-slimibas_lv.json": [
		93526,
		93526
	],
	"./health-issues/seksuali-transmisivas-slimibas-sts-/seksuali-transmisivas-slimibas_ru.json": [
		19288,
		19288
	],
	"./health-issues/seksuali-transmisivas-slimibas-sts-/sifiliss_en.json": [
		59999,
		59999
	],
	"./health-issues/seksuali-transmisivas-slimibas-sts-/sifiliss_lv.json": [
		74949,
		74949
	],
	"./health-issues/seksuali-transmisivas-slimibas-sts-/sifiliss_ru.json": [
		58179,
		58179
	],
	"./health-issues/seksuali-transmisivas-slimibas_en.json": [
		1700,
		1700
	],
	"./health-issues/seksuali-transmisivas-slimibas_lv.json": [
		33520,
		33520
	],
	"./health-issues/seksuali-transmisivas-slimibas_ru.json": [
		56864,
		56864
	],
	"./health-issues/sifiliss_en.json": [
		58773,
		58773
	],
	"./health-issues/sifiliss_lv.json": [
		14179,
		14179
	],
	"./health-issues/sifiliss_ru.json": [
		91349,
		91349
	],
	"./health-issues/sinusa-tahikardija_en.json": [
		52310,
		52310
	],
	"./health-issues/sinusa-tahikardija_lv.json": [
		84572,
		84572
	],
	"./health-issues/sinusa-tahikardija_ru.json": [
		41834,
		41834
	],
	"./health-issues/sinusits_en.json": [
		61279,
		61279
	],
	"./health-issues/sinusits_lv.json": [
		20370,
		20370
	],
	"./health-issues/sinusits_ru.json": [
		15497,
		15497
	],
	"./health-issues/sirds-aritmija_en.json": [
		53837,
		53837
	],
	"./health-issues/sirds-aritmija_lv.json": [
		63846,
		63846
	],
	"./health-issues/sirds-aritmija_ru.json": [
		80758,
		80758
	],
	"./health-issues/sirds-mazspeja_en.json": [
		96687,
		96687
	],
	"./health-issues/sirds-mazspeja_lv.json": [
		55505,
		55505
	],
	"./health-issues/sirds-mazspeja_ru.json": [
		61174,
		61174
	],
	"./health-issues/skarlatina_en.json": [
		81868,
		81868
	],
	"./health-issues/skarlatina_lv.json": [
		77927,
		77927
	],
	"./health-issues/skarlatina_ru.json": [
		62933,
		62933
	],
	"./health-issues/sklerodermija_en.json": [
		49932,
		49932
	],
	"./health-issues/sklerodermija_lv.json": [
		85563,
		85563
	],
	"./health-issues/sklerodermija_ru.json": [
		83235,
		83235
	],
	"./health-issues/smadzenu-insults_en.json": [
		23338,
		23338
	],
	"./health-issues/smadzenu-insults_lv.json": [
		12032,
		12032
	],
	"./health-issues/smadzenu-insults_ru.json": [
		20728,
		20728
	],
	"./health-issues/smadzenu-satricinajums_en.json": [
		15688,
		15688
	],
	"./health-issues/smadzenu-satricinajums_lv.json": [
		2002,
		2002
	],
	"./health-issues/smadzenu-satricinajums_ru.json": [
		43459,
		43459
	],
	"./health-issues/sociala-trauksme_en.json": [
		92647,
		92647
	],
	"./health-issues/sociala-trauksme_lv.json": [
		32471,
		32471
	],
	"./health-issues/sociala-trauksme_ru.json": [
		34805,
		34805
	],
	"./health-issues/tahikardija-kad-sirds-sitas-parak-atri_en.json": [
		19182,
		19182
	],
	"./health-issues/tahikardija-kad-sirds-sitas-parak-atri_lv.json": [
		23409,
		23409
	],
	"./health-issues/tahikardija-kad-sirds-sitas-parak-atri_ru.json": [
		39132,
		39132
	],
	"./health-issues/tava-aknu-veseliba-ka-saprast-hepatita-riskus-_en.json": [
		90373,
		90373
	],
	"./health-issues/tava-aknu-veseliba-ka-saprast-hepatita-riskus-_lv.json": [
		62709,
		62709
	],
	"./health-issues/tava-aknu-veseliba-ka-saprast-hepatita-riskus-_ru.json": [
		98579,
		98579
	],
	"./health-issues/trauksme_en.json": [
		79249,
		79249
	],
	"./health-issues/trauksme_lv.json": [
		93534,
		93534
	],
	"./health-issues/trauksme_ru.json": [
		38348,
		38348
	],
	"./health-issues/tuberkoloze_en.json": [
		24089,
		24089
	],
	"./health-issues/tuberkoloze_lv.json": [
		14698,
		14698
	],
	"./health-issues/tuberkoloze_ru.json": [
		4148,
		4148
	],
	"./health-issues/tuberkuloze_en.json": [
		23587,
		23587
	],
	"./health-issues/tuberkuloze_lv.json": [
		10699,
		10699
	],
	"./health-issues/tuberkuloze_ru.json": [
		45984,
		45984
	],
	"./health-issues/urina-nesaturesana_en.json": [
		80701,
		80701
	],
	"./health-issues/urina-nesaturesana_lv.json": [
		91481,
		91481
	],
	"./health-issues/urina-nesaturesana_ru.json": [
		94330,
		94330
	],
	"./health-issues/urincelu-infekcija_en.json": [
		38009,
		38009
	],
	"./health-issues/urincelu-infekcija_lv.json": [
		55039,
		55039
	],
	"./health-issues/urincelu-infekcija_ru.json": [
		17544,
		17544
	],
	"./health-issues/urologiskas-problemas/_all_en.json": [
		35342,
		35342
	],
	"./health-issues/urologiskas-problemas/_all_lv.json": [
		31650,
		31650
	],
	"./health-issues/urologiskas-problemas/_all_ru.json": [
		16751,
		16751
	],
	"./health-issues/urologiskas-problemas/asinis-urina_en.json": [
		86951,
		86951
	],
	"./health-issues/urologiskas-problemas/asinis-urina_lv.json": [
		73550,
		73550
	],
	"./health-issues/urologiskas-problemas/asinis-urina_ru.json": [
		8718,
		8718
	],
	"./health-issues/urologiskas-problemas/cistits_en.json": [
		7115,
		7115
	],
	"./health-issues/urologiskas-problemas/cistits_lv.json": [
		5148,
		5148
	],
	"./health-issues/urologiskas-problemas/cistits_ru.json": [
		71836,
		71836
	],
	"./health-issues/urologiskas-problemas/dulkains-urins_en.json": [
		24050,
		24050
	],
	"./health-issues/urologiskas-problemas/dulkains-urins_lv.json": [
		91831,
		91831
	],
	"./health-issues/urologiskas-problemas/dulkains-urins_ru.json": [
		58921,
		58921
	],
	"./health-issues/urologiskas-problemas/hidroenfroze_en.json": [
		86287,
		86287
	],
	"./health-issues/urologiskas-problemas/hidroenfroze_lv.json": [
		99880,
		99880
	],
	"./health-issues/urologiskas-problemas/hidroenfroze_ru.json": [
		43096,
		43096
	],
	"./health-issues/urologiskas-problemas/nierakmeni_en.json": [
		48130,
		48130
	],
	"./health-issues/urologiskas-problemas/nierakmeni_lv.json": [
		57328,
		57328
	],
	"./health-issues/urologiskas-problemas/nierakmeni_ru.json": [
		82556,
		82556
	],
	"./health-issues/urologiskas-problemas/nieru-mazspeja_en.json": [
		38722,
		38722
	],
	"./health-issues/urologiskas-problemas/nieru-mazspeja_lv.json": [
		60911,
		60911
	],
	"./health-issues/urologiskas-problemas/nieru-mazspeja_ru.json": [
		45389,
		45389
	],
	"./health-issues/urologiskas-problemas/nieru-slimibas_en.json": [
		76266,
		76266
	],
	"./health-issues/urologiskas-problemas/nieru-slimibas_lv.json": [
		27606,
		27606
	],
	"./health-issues/urologiskas-problemas/nieru-slimibas_ru.json": [
		16717,
		16717
	],
	"./health-issues/urologiskas-problemas/pielonefrits_en.json": [
		12865,
		12865
	],
	"./health-issues/urologiskas-problemas/pielonefrits_lv.json": [
		23228,
		23228
	],
	"./health-issues/urologiskas-problemas/pielonefrits_ru.json": [
		79559,
		79559
	],
	"./health-issues/urologiskas-problemas/priapisms_en.json": [
		54750,
		54750
	],
	"./health-issues/urologiskas-problemas/priapisms_lv.json": [
		80605,
		80605
	],
	"./health-issues/urologiskas-problemas/priapisms_ru.json": [
		80117,
		80117
	],
	"./health-issues/urologiskas-problemas/prostatas-hiperplazija_en.json": [
		1534,
		1534
	],
	"./health-issues/urologiskas-problemas/prostatas-hiperplazija_lv.json": [
		22212,
		22212
	],
	"./health-issues/urologiskas-problemas/prostatas-hiperplazija_ru.json": [
		42126,
		42126
	],
	"./health-issues/urologiskas-problemas/prostatas-iekaisums_en.json": [
		2944,
		2944
	],
	"./health-issues/urologiskas-problemas/prostatas-iekaisums_lv.json": [
		43529,
		43529
	],
	"./health-issues/urologiskas-problemas/prostatas-iekaisums_ru.json": [
		22783,
		22783
	],
	"./health-issues/urologiskas-problemas/prostatits_en.json": [
		42884,
		42884
	],
	"./health-issues/urologiskas-problemas/prostatits_lv.json": [
		7477,
		7477
	],
	"./health-issues/urologiskas-problemas/prostatits_ru.json": [
		80515,
		80515
	],
	"./health-issues/urologiskas-problemas/urina-nesaturesana_en.json": [
		6684,
		6684
	],
	"./health-issues/urologiskas-problemas/urina-nesaturesana_lv.json": [
		8174,
		8174
	],
	"./health-issues/urologiskas-problemas/urina-nesaturesana_ru.json": [
		78032,
		78032
	],
	"./health-issues/urologiskas-problemas/urincelu-infekcija_en.json": [
		95874,
		95874
	],
	"./health-issues/urologiskas-problemas/urincelu-infekcija_lv.json": [
		21148,
		21148
	],
	"./health-issues/urologiskas-problemas/urincelu-infekcija_ru.json": [
		61351,
		61351
	],
	"./health-issues/urologiskas-problemas_en.json": [
		9835,
		9835
	],
	"./health-issues/urologiskas-problemas_lv.json": [
		89751,
		89751
	],
	"./health-issues/urologiskas-problemas_ru.json": [
		85842,
		85842
	],
	"./health-issues/vejbakas_en.json": [
		57208,
		57208
	],
	"./health-issues/vejbakas_lv.json": [
		67025,
		67025
	],
	"./health-issues/vejbakas_ru.json": [
		55655,
		55655
	],
	"./health-issues/vezis/_all_en.json": [
		25915,
		25915
	],
	"./health-issues/vezis/_all_lv.json": [
		1707,
		1707
	],
	"./health-issues/vezis/_all_ru.json": [
		8346,
		8346
	],
	"./health-issues/vezis/kad-zarnu-darbiba-signalize-ko-nopietnu-izproti-zarnu-veza-pazimes_en.json": [
		92896,
		92896
	],
	"./health-issues/vezis/kad-zarnu-darbiba-signalize-ko-nopietnu-izproti-zarnu-veza-pazimes_lv.json": [
		64869,
		64869
	],
	"./health-issues/vezis/kad-zarnu-darbiba-signalize-ko-nopietnu-izproti-zarnu-veza-pazimes_ru.json": [
		87631,
		87631
	],
	"./health-issues/vezis/kunga-vezis-simptomi-kurus-nedrikst-ignoret_en.json": [
		94025,
		94025
	],
	"./health-issues/vezis/kunga-vezis-simptomi-kurus-nedrikst-ignoret_lv.json": [
		93925,
		93925
	],
	"./health-issues/vezis/kunga-vezis-simptomi-kurus-nedrikst-ignoret_ru.json": [
		54549,
		54549
	],
	"./health-issues/vezis/leikemija-ka-laikus-atpazit-un-kur-meklet-palidzibu_en.json": [
		25385,
		25385
	],
	"./health-issues/vezis/leikemija-ka-laikus-atpazit-un-kur-meklet-palidzibu_lv.json": [
		27958,
		27958
	],
	"./health-issues/vezis/leikemija-ka-laikus-atpazit-un-kur-meklet-palidzibu_ru.json": [
		65666,
		65666
	],
	"./health-issues/vezis/no-dzimumzimes-lidz-diagnozei-patiesiba-par-melanomu_en.json": [
		54444,
		54444
	],
	"./health-issues/vezis/no-dzimumzimes-lidz-diagnozei-patiesiba-par-melanomu_lv.json": [
		75216,
		75216
	],
	"./health-issues/vezis/no-dzimumzimes-lidz-diagnozei-patiesiba-par-melanomu_ru.json": [
		4654,
		4654
	],
	"./health-issues/vezis/parbaudi-savu-adu-adas-vezis-var-sakties-nemanami_en.json": [
		95970,
		95970
	],
	"./health-issues/vezis/parbaudi-savu-adu-adas-vezis-var-sakties-nemanami_lv.json": [
		20267,
		20267
	],
	"./health-issues/vezis/parbaudi-savu-adu-adas-vezis-var-sakties-nemanami_ru.json": [
		58076,
		58076
	],
	"./health-issues/vezis/viss-kas-jazina-par-dzemdes-kakla-vezi-no-riskiem-lidz-profilaksei_en.json": [
		98446,
		98446
	],
	"./health-issues/vezis/viss-kas-jazina-par-dzemdes-kakla-vezi-no-riskiem-lidz-profilaksei_lv.json": [
		75632,
		75632
	],
	"./health-issues/vezis/viss-kas-jazina-par-dzemdes-kakla-vezi-no-riskiem-lidz-profilaksei_ru.json": [
		9654,
		9654
	],
	"./health-issues/vezis/viss-kas-jazina-par-plausu-vezi-no-riska-faktoriem-lidz-diagnostikai_en.json": [
		95269,
		95269
	],
	"./health-issues/vezis/viss-kas-jazina-par-plausu-vezi-no-riska-faktoriem-lidz-diagnostikai_lv.json": [
		86571,
		86571
	],
	"./health-issues/vezis/viss-kas-jazina-par-plausu-vezi-no-riska-faktoriem-lidz-diagnostikai_ru.json": [
		32176,
		32176
	],
	"./health-issues/vezis_en.json": [
		59520,
		59520
	],
	"./health-issues/vezis_lv.json": [
		11327,
		11327
	],
	"./health-issues/vezis_ru.json": [
		30264,
		30264
	],
	"./health-issues/viss-kas-jazina-par-dzemdes-kakla-vezi-no-riskiem-lidz-profilaksei_en.json": [
		33183,
		33183
	],
	"./health-issues/viss-kas-jazina-par-dzemdes-kakla-vezi-no-riskiem-lidz-profilaksei_lv.json": [
		47357,
		47357
	],
	"./health-issues/viss-kas-jazina-par-dzemdes-kakla-vezi-no-riskiem-lidz-profilaksei_ru.json": [
		11536,
		11536
	],
	"./health-issues/viss-kas-jazina-par-plausu-vezi-no-riska-faktoriem-lidz-diagnostikai_en.json": [
		66167,
		66167
	],
	"./health-issues/viss-kas-jazina-par-plausu-vezi-no-riska-faktoriem-lidz-diagnostikai_lv.json": [
		96358,
		96358
	],
	"./health-issues/viss-kas-jazina-par-plausu-vezi-no-riska-faktoriem-lidz-diagnostikai_ru.json": [
		97097,
		97097
	],
	"./health-issues/viss-kas-jazina-par-seksu-menesreizu-laika_en.json": [
		1323,
		1323
	],
	"./health-issues/viss-kas-jazina-par-seksu-menesreizu-laika_lv.json": [
		30458,
		30458
	],
	"./health-issues/viss-kas-jazina-par-seksu-menesreizu-laika_ru.json": [
		99144,
		99144
	],
	"./health-issues/vitiligo_en.json": [
		33011,
		33011
	],
	"./health-issues/vitiligo_lv.json": [
		30697,
		30697
	],
	"./health-issues/vitiligo_ru.json": [
		86025,
		86025
	],
	"./health-issues/zarnu-mikrobioma-lidzsvara-traucejumi-jeb-disbakterioze-ko-darit-_en.json": [
		25520,
		25520
	],
	"./health-issues/zarnu-mikrobioma-lidzsvara-traucejumi-jeb-disbakterioze-ko-darit-_lv.json": [
		34247,
		34247
	],
	"./health-issues/zarnu-mikrobioma-lidzsvara-traucejumi-jeb-disbakterioze-ko-darit-_ru.json": [
		5970,
		5970
	],
	"./health-issues/zarnu-polipi-agrins-signals-nopietnakam-veselibas-problemam-_en.json": [
		63702,
		63702
	],
	"./health-issues/zarnu-polipi-agrins-signals-nopietnakam-veselibas-problemam-_lv.json": [
		29304,
		87018
	],
	"./health-issues/zarnu-polipi-agrins-signals-nopietnakam-veselibas-problemam-_ru.json": [
		4758,
		4758
	],
	"./health-issues_en.json": [
		48328,
		48328
	],
	"./health-issues_lv.json": [
		35754,
		35754
	],
	"./health-issues_ru.json": [
		92112,
		92112
	],
	"./landings/anti-aging-programma-saglaba-jaunibu-old_en.json": [
		80429,
		80429
	],
	"./landings/anti-aging-programma-saglaba-jaunibu-old_lv.json": [
		52618,
		52618
	],
	"./landings/anti-aging-programma-saglaba-jaunibu-old_ru.json": [
		34653,
		34653
	],
	"./landings/anti-aging-programma-saglaba-jaunibu_en.json": [
		68539,
		68539
	],
	"./landings/anti-aging-programma-saglaba-jaunibu_lv.json": [
		65672,
		65672
	],
	"./landings/anti-aging-programma-saglaba-jaunibu_ru.json": [
		5942,
		5942
	],
	"./landings/arzemju-pacientiem-copy_en.json": [
		2845,
		2845
	],
	"./landings/arzemju-pacientiem-copy_lv.json": [
		48792,
		93201
	],
	"./landings/arzemju-pacientiem-copy_ru.json": [
		17132,
		17132
	],
	"./landings/arzemju-pacientiem_en.json": [
		27835,
		27835
	],
	"./landings/arzemju-pacientiem_lv.json": [
		22058,
		22058
	],
	"./landings/arzemju-pacientiem_ru.json": [
		15138,
		15138
	],
	"./landings/balcia_en.json": [
		55880,
		55880
	],
	"./landings/balcia_lv.json": [
		47413,
		47413
	],
	"./landings/balcia_ru.json": [
		26842,
		26842
	],
	"./landings/diabets-aptaukosanas_en.json": [
		12636,
		12636
	],
	"./landings/diabets-aptaukosanas_lv.json": [
		64077,
		64077
	],
	"./landings/diabets-aptaukosanas_ru.json": [
		28629,
		28629
	],
	"./landings/ergo_en.json": [
		56367,
		56367
	],
	"./landings/ergo_lv.json": [
		43980,
		43980
	],
	"./landings/ergo_ru.json": [
		89927,
		89927
	],
	"./landings/hormonu-lidzsvara-programma-harmoniska-veseliba_en.json": [
		32102,
		32102
	],
	"./landings/hormonu-lidzsvara-programma-harmoniska-veseliba_lv.json": [
		99542,
		99542
	],
	"./landings/hormonu-lidzsvara-programma-harmoniska-veseliba_ru.json": [
		99805,
		99805
	],
	"./landings/kardiovaskularo-risku-samazinasanas-programma-sirds-specigai-nakotnei_en.json": [
		77250,
		77250
	],
	"./landings/kardiovaskularo-risku-samazinasanas-programma-sirds-specigai-nakotnei_lv.json": [
		54642,
		54642
	],
	"./landings/kardiovaskularo-risku-samazinasanas-programma-sirds-specigai-nakotnei_ru.json": [
		18647,
		18647
	],
	"./landings/myfitness-vadosais-fitnesa-klubu-tikls-latvija_en.json": [
		59399,
		59399
	],
	"./landings/myfitness-vadosais-fitnesa-klubu-tikls-latvija_lv.json": [
		2661,
		2661
	],
	"./landings/myfitness-vadosais-fitnesa-klubu-tikls-latvija_ru.json": [
		80144,
		80144
	],
	"./landings/pediatri_en.json": [
		26900,
		26900
	],
	"./landings/pediatri_lv.json": [
		96335,
		96335
	],
	"./landings/pediatri_ru.json": [
		97750,
		97750
	],
	"./landings/piedalies-un-laime_en.json": [
		10561,
		10561
	],
	"./landings/piedalies-un-laime_lv.json": [
		67956,
		67956
	],
	"./landings/piedalies-un-laime_ru.json": [
		91219,
		91219
	],
	"./landings/sieviesu-veselibas-programma-veselibas-uzraviens-sievietem-pec-40_en.json": [
		8084,
		8084
	],
	"./landings/sieviesu-veselibas-programma-veselibas-uzraviens-sievietem-pec-40_lv.json": [
		15795,
		15795
	],
	"./landings/sieviesu-veselibas-programma-veselibas-uzraviens-sievietem-pec-40_ru.json": [
		51774,
		51774
	],
	"./landings/testnewspecialitypage_en.json": [
		101,
		101
	],
	"./landings/testnewspecialitypage_lv.json": [
		4302,
		4302
	],
	"./landings/testnewspecialitypage_ru.json": [
		93524,
		93524
	],
	"./landings/uznemumiem-pieteiksanas_en.json": [
		99357,
		99357
	],
	"./landings/uznemumiem-pieteiksanas_lv.json": [
		9350,
		9350
	],
	"./landings/uznemumiem-pieteiksanas_ru.json": [
		32651,
		32651
	],
	"./landings/uznemumiem_en.json": [
		13823,
		13823
	],
	"./landings/uznemumiem_lv.json": [
		37770,
		37770
	],
	"./landings/uznemumiem_ru.json": [
		43003,
		43003
	],
	"./landings/veselibas-programmas-old_en.json": [
		50737,
		50737
	],
	"./landings/veselibas-programmas-old_lv.json": [
		30349,
		30349
	],
	"./landings/veselibas-programmas-old_ru.json": [
		91965,
		91965
	],
	"./landings/veselibas-programmas-sieviesu-veselibas-programma_en.json": [
		40844,
		40844
	],
	"./landings/veselibas-programmas-sieviesu-veselibas-programma_lv.json": [
		84034,
		84034
	],
	"./landings/veselibas-programmas-sieviesu-veselibas-programma_ru.json": [
		49754,
		49754
	],
	"./landings/veselibas-programmas2_en.json": [
		58232,
		58232
	],
	"./landings/veselibas-programmas2_lv.json": [
		25097,
		25097
	],
	"./landings/veselibas-programmas2_ru.json": [
		19239,
		19239
	],
	"./landings/veselibas-programmas_en.json": [
		23143,
		23143
	],
	"./landings/veselibas-programmas_lv.json": [
		55791,
		55791
	],
	"./landings/veselibas-programmas_ru.json": [
		20920,
		20920
	],
	"./specialities/algologs_en.json": [
		74803,
		74803
	],
	"./specialities/algologs_lv.json": [
		94177,
		94177
	],
	"./specialities/algologs_ru.json": [
		12227,
		12227
	],
	"./specialities/anesteziologs-reanimatologs_en.json": [
		12607,
		12607
	],
	"./specialities/anesteziologs-reanimatologs_lv.json": [
		34218,
		34218
	],
	"./specialities/anesteziologs-reanimatologs_ru.json": [
		15462,
		15462
	],
	"./specialities/bernu-neirologs_en.json": [
		68032,
		68032
	],
	"./specialities/bernu-neirologs_lv.json": [
		17121,
		17121
	],
	"./specialities/bernu-neirologs_ru.json": [
		81422,
		81422
	],
	"./specialities/bernu-pneimologs_en.json": [
		6330,
		6330
	],
	"./specialities/bernu-pneimologs_lv.json": [
		81532,
		81532
	],
	"./specialities/bernu-pneimologs_ru.json": [
		25612,
		25612
	],
	"./specialities/bernu-pneimonologs_en.json": [
		10501,
		10501
	],
	"./specialities/bernu-pneimonologs_lv.json": [
		64165,
		64165
	],
	"./specialities/bernu-pneimonologs_ru.json": [
		42306,
		42306
	],
	"./specialities/bernu-psihiatrs_en.json": [
		71860,
		71860
	],
	"./specialities/bernu-psihiatrs_lv.json": [
		3665,
		3665
	],
	"./specialities/bernu-psihiatrs_ru.json": [
		66411,
		66411
	],
	"./specialities/dermatologs-venerologs_en.json": [
		71913,
		71913
	],
	"./specialities/dermatologs-venerologs_lv.json": [
		65089,
		65089
	],
	"./specialities/dermatologs-venerologs_ru.json": [
		73909,
		73909
	],
	"./specialities/dermatologs_en.json": [
		54261,
		54261
	],
	"./specialities/dermatologs_lv.json": [
		98251,
		98251
	],
	"./specialities/dermatologs_ru.json": [
		68458,
		68458
	],
	"./specialities/dzemdibu-specialists_en.json": [
		89963,
		89963
	],
	"./specialities/dzemdibu-specialists_lv.json": [
		17461,
		17461
	],
	"./specialities/dzemdibu-specialists_ru.json": [
		48844,
		48844
	],
	"./specialities/endokrinologs_en.json": [
		86378,
		86378
	],
	"./specialities/endokrinologs_lv.json": [
		87217,
		87217
	],
	"./specialities/endokrinologs_ru.json": [
		49445,
		49445
	],
	"./specialities/ergoterapeits_en.json": [
		95065,
		95065
	],
	"./specialities/ergoterapeits_lv.json": [
		75798,
		75798
	],
	"./specialities/ergoterapeits_ru.json": [
		39520,
		39520
	],
	"./specialities/fizioterapeits_en.json": [
		84852,
		84852
	],
	"./specialities/fizioterapeits_lv.json": [
		91543,
		91543
	],
	"./specialities/fizioterapeits_ru.json": [
		48241,
		48241
	],
	"./specialities/gimenes-arsts_en.json": [
		12185,
		12185
	],
	"./specialities/gimenes-arsts_lv.json": [
		30660,
		30660
	],
	"./specialities/gimenes-arsts_ru.json": [
		46253,
		46253
	],
	"./specialities/gimenes-visparejas-prakses-arsts_en.json": [
		51806,
		51806
	],
	"./specialities/gimenes-visparejas-prakses-arsts_lv.json": [
		64759,
		64759
	],
	"./specialities/gimenes-visparejas-prakses-arsts_ru.json": [
		20200,
		20200
	],
	"./specialities/ginekologs-dzemdibu-specialists_en.json": [
		34736,
		34736
	],
	"./specialities/ginekologs-dzemdibu-specialists_lv.json": [
		72086,
		72086
	],
	"./specialities/ginekologs-dzemdibu-specialists_ru.json": [
		78881,
		78881
	],
	"./specialities/ginekologs_en.json": [
		58856,
		58856
	],
	"./specialities/ginekologs_lv.json": [
		27924,
		27924
	],
	"./specialities/ginekologs_ru.json": [
		59183,
		59183
	],
	"./specialities/integrativais-onkologs_en.json": [
		96002,
		96002
	],
	"./specialities/integrativais-onkologs_lv.json": [
		91098,
		91098
	],
	"./specialities/integrativais-onkologs_ru.json": [
		61935,
		61935
	],
	"./specialities/internists_en.json": [
		84601,
		54296
	],
	"./specialities/internists_lv.json": [
		42173,
		42173
	],
	"./specialities/internists_ru.json": [
		95415,
		95415
	],
	"./specialities/kardiologs_en.json": [
		9727,
		9727
	],
	"./specialities/kardiologs_lv.json": [
		61541,
		61541
	],
	"./specialities/kardiologs_ru.json": [
		60150,
		60150
	],
	"./specialities/kirurgs_en.json": [
		35245,
		35245
	],
	"./specialities/kirurgs_lv.json": [
		53608,
		53608
	],
	"./specialities/kirurgs_ru.json": [
		59633,
		59633
	],
	"./specialities/kliniskais-un-veselibas-psihologs_en.json": [
		29176,
		29176
	],
	"./specialities/kliniskais-un-veselibas-psihologs_lv.json": [
		3490,
		3490
	],
	"./specialities/kliniskais-un-veselibas-psihologs_ru.json": [
		42093,
		84601
	],
	"./specialities/nefrologs_en.json": [
		35984,
		35984
	],
	"./specialities/nefrologs_lv.json": [
		82943,
		82943
	],
	"./specialities/nefrologs_ru.json": [
		36686,
		36686
	],
	"./specialities/neirologs_en.json": [
		78721,
		78721
	],
	"./specialities/neirologs_lv.json": [
		71958,
		71958
	],
	"./specialities/neirologs_ru.json": [
		20472,
		20472
	],
	"./specialities/oftalmologs_en.json": [
		93521,
		93521
	],
	"./specialities/oftalmologs_lv.json": [
		5691,
		5691
	],
	"./specialities/oftalmologs_ru.json": [
		27075,
		27075
	],
	"./specialities/onkologs_en.json": [
		97856,
		97856
	],
	"./specialities/onkologs_lv.json": [
		10289,
		10289
	],
	"./specialities/onkologs_ru.json": [
		8892,
		8892
	],
	"./specialities/otolaringologs_en.json": [
		8415,
		8415
	],
	"./specialities/otolaringologs_lv.json": [
		37955,
		37955
	],
	"./specialities/otolaringologs_ru.json": [
		20435,
		20435
	],
	"./specialities/otorinolaringologs_en.json": [
		7554,
		7554
	],
	"./specialities/otorinolaringologs_lv.json": [
		76177,
		76177
	],
	"./specialities/otorinolaringologs_ru.json": [
		72386,
		72386
	],
	"./specialities/pediatrs_en.json": [
		27591,
		27591
	],
	"./specialities/pediatrs_lv.json": [
		15015,
		15015
	],
	"./specialities/pediatrs_ru.json": [
		77493,
		77493
	],
	"./specialities/psihiatrs_en.json": [
		21581,
		21581
	],
	"./specialities/psihiatrs_lv.json": [
		55683,
		55683
	],
	"./specialities/psihiatrs_ru.json": [
		37136,
		37136
	],
	"./specialities/psihiskas-veselibas-specialisti_en.json": [
		44952,
		44952
	],
	"./specialities/psihiskas-veselibas-specialisti_lv.json": [
		80092,
		80092
	],
	"./specialities/psihiskas-veselibas-specialisti_ru.json": [
		22599,
		22599
	],
	"./specialities/psihoterapeits_en.json": [
		64087,
		64087
	],
	"./specialities/psihoterapeits_lv.json": [
		28570,
		28570
	],
	"./specialities/psihoterapeits_ru.json": [
		74771,
		74771
	],
	"./specialities/reimatologs_en.json": [
		12638,
		12638
	],
	"./specialities/reimatologs_lv.json": [
		43684,
		43684
	],
	"./specialities/reimatologs_ru.json": [
		27384,
		27384
	],
	"./specialities/sirds-kirurgs_en.json": [
		23162,
		23162
	],
	"./specialities/sirds-kirurgs_lv.json": [
		34839,
		34839
	],
	"./specialities/sirds-kirurgs_ru.json": [
		46683,
		46683
	],
	"./specialities/sporta-arsts_en.json": [
		50833,
		50833
	],
	"./specialities/sporta-arsts_lv.json": [
		74094,
		74094
	],
	"./specialities/sporta-arsts_ru.json": [
		71957,
		71957
	],
	"./specialities/torakalais-kirurgs_en.json": [
		22063,
		22063
	],
	"./specialities/torakalais-kirurgs_lv.json": [
		28673,
		28673
	],
	"./specialities/torakalais-kirurgs_ru.json": [
		8439,
		8439
	],
	"./specialities/traumatologs-ortopeds_en.json": [
		87803,
		87803
	],
	"./specialities/traumatologs-ortopeds_lv.json": [
		15556,
		15556
	],
	"./specialities/traumatologs-ortopeds_ru.json": [
		21759,
		21759
	],
	"./specialities/traumatologs_en.json": [
		73566,
		73566
	],
	"./specialities/traumatologs_lv.json": [
		32849,
		32849
	],
	"./specialities/traumatologs_ru.json": [
		2700,
		2700
	],
	"./specialities/trihologs_en.json": [
		62777,
		62777
	],
	"./specialities/trihologs_lv.json": [
		44173,
		44173
	],
	"./specialities/trihologs_ru.json": [
		50529,
		50529
	],
	"./specialities/urologs_en.json": [
		67213,
		67213
	],
	"./specialities/urologs_lv.json": [
		37085,
		37085
	],
	"./specialities/urologs_ru.json": [
		34432,
		34432
	],
	"./specialities/uztura-specialists_en.json": [
		44620,
		44620
	],
	"./specialities/uztura-specialists_lv.json": [
		48745,
		48745
	],
	"./specialities/uztura-specialists_ru.json": [
		48124,
		48124
	],
	"./specialities/vecmate_en.json": [
		66050,
		66050
	],
	"./specialities/vecmate_lv.json": [
		42243,
		42243
	],
	"./specialities/vecmate_ru.json": [
		75993,
		75993
	],
	"./specialities2/algologs_en.json": [
		99085,
		99085
	],
	"./specialities2/algologs_lv.json": [
		23417,
		23417
	],
	"./specialities2/algologs_ru.json": [
		23190,
		23190
	],
	"./specialities2/anesteziologs-reanimatologs_en.json": [
		82808,
		82808
	],
	"./specialities2/anesteziologs-reanimatologs_lv.json": [
		85497,
		85497
	],
	"./specialities2/anesteziologs-reanimatologs_ru.json": [
		18651,
		18651
	],
	"./specialities2/bernu-neirologs_en.json": [
		4187,
		4187
	],
	"./specialities2/bernu-neirologs_lv.json": [
		31351,
		31351
	],
	"./specialities2/bernu-neirologs_ru.json": [
		23511,
		23511
	],
	"./specialities2/bernu-pneimologs_en.json": [
		26380,
		26380
	],
	"./specialities2/bernu-pneimologs_lv.json": [
		2247,
		2247
	],
	"./specialities2/bernu-pneimologs_ru.json": [
		45577,
		45577
	],
	"./specialities2/bernu-pneimonologs_en.json": [
		36913,
		36913
	],
	"./specialities2/bernu-pneimonologs_lv.json": [
		50394,
		50394
	],
	"./specialities2/bernu-pneimonologs_ru.json": [
		56105,
		56105
	],
	"./specialities2/bernu-psihiatrs_en.json": [
		42501,
		42501
	],
	"./specialities2/bernu-psihiatrs_lv.json": [
		21772,
		21772
	],
	"./specialities2/bernu-psihiatrs_ru.json": [
		52966,
		52966
	],
	"./specialities2/dermatologs_en.json": [
		58372,
		58372
	],
	"./specialities2/dermatologs_lv.json": [
		79466,
		79466
	],
	"./specialities2/dermatologs_ru.json": [
		89005,
		89005
	],
	"./specialities2/endokrinologs_en.json": [
		30605,
		30605
	],
	"./specialities2/endokrinologs_lv.json": [
		20585,
		20585
	],
	"./specialities2/endokrinologs_ru.json": [
		38984,
		38984
	],
	"./specialities2/ergoterapeits_en.json": [
		14171,
		14171
	],
	"./specialities2/ergoterapeits_lv.json": [
		13516,
		13516
	],
	"./specialities2/ergoterapeits_ru.json": [
		56710,
		56710
	],
	"./specialities2/fizioterapeits_en.json": [
		49417,
		49417
	],
	"./specialities2/fizioterapeits_lv.json": [
		3641,
		3641
	],
	"./specialities2/fizioterapeits_ru.json": [
		67580,
		67580
	],
	"./specialities2/gastroenterologs_en.json": [
		44415,
		44415
	],
	"./specialities2/gastroenterologs_lv.json": [
		5247,
		5247
	],
	"./specialities2/gastroenterologs_ru.json": [
		70162,
		70162
	],
	"./specialities2/gimenes-arsts_en.json": [
		60890,
		60890
	],
	"./specialities2/gimenes-arsts_lv.json": [
		4500,
		4500
	],
	"./specialities2/gimenes-arsts_ru.json": [
		27758,
		27758
	],
	"./specialities2/gimenes-visparejas-prakses-arsts_en.json": [
		3246,
		3246
	],
	"./specialities2/gimenes-visparejas-prakses-arsts_lv.json": [
		75339,
		75339
	],
	"./specialities2/gimenes-visparejas-prakses-arsts_ru.json": [
		88353,
		88353
	],
	"./specialities2/ginekologs_en.json": [
		90953,
		90953
	],
	"./specialities2/ginekologs_lv.json": [
		81953,
		81953
	],
	"./specialities2/ginekologs_ru.json": [
		78329,
		78329
	],
	"./specialities2/internists_en.json": [
		46847,
		46847
	],
	"./specialities2/internists_lv.json": [
		5581,
		5581
	],
	"./specialities2/internists_ru.json": [
		38119,
		38119
	],
	"./specialities2/kardiologs_en.json": [
		69569,
		69569
	],
	"./specialities2/kardiologs_lv.json": [
		80824,
		80824
	],
	"./specialities2/kardiologs_ru.json": [
		93464,
		93464
	],
	"./specialities2/kirurgs_en.json": [
		73316,
		73316
	],
	"./specialities2/kirurgs_lv.json": [
		13310,
		13310
	],
	"./specialities2/kirurgs_ru.json": [
		86601,
		86601
	],
	"./specialities2/kliniskais-psihologs_en.json": [
		27512,
		27512
	],
	"./specialities2/kliniskais-psihologs_lv.json": [
		88539,
		88539
	],
	"./specialities2/kliniskais-psihologs_ru.json": [
		60902,
		60902
	],
	"./specialities2/makslas-terapeits_en.json": [
		33574,
		33574
	],
	"./specialities2/makslas-terapeits_lv.json": [
		11265,
		11265
	],
	"./specialities2/makslas-terapeits_ru.json": [
		99470,
		99470
	],
	"./specialities2/neatliekamas-medicinas-arsts_en.json": [
		54533,
		54533
	],
	"./specialities2/neatliekamas-medicinas-arsts_lv.json": [
		80891,
		80891
	],
	"./specialities2/neatliekamas-medicinas-arsts_ru.json": [
		86981,
		86981
	],
	"./specialities2/nefrologs_en.json": [
		72813,
		72813
	],
	"./specialities2/nefrologs_lv.json": [
		69204,
		69204
	],
	"./specialities2/nefrologs_ru.json": [
		54095,
		54095
	],
	"./specialities2/neirologs_en.json": [
		12021,
		12021
	],
	"./specialities2/neirologs_lv.json": [
		97917,
		97917
	],
	"./specialities2/neirologs_ru.json": [
		18124,
		18124
	],
	"./specialities2/oftalmologs_en.json": [
		36302,
		36302
	],
	"./specialities2/oftalmologs_lv.json": [
		83414,
		83414
	],
	"./specialities2/oftalmologs_ru.json": [
		72499,
		72499
	],
	"./specialities2/onkologs_en.json": [
		46722,
		46722
	],
	"./specialities2/onkologs_lv.json": [
		67862,
		67862
	],
	"./specialities2/onkologs_ru.json": [
		45949,
		45949
	],
	"./specialities2/otorinolaringologs_en.json": [
		90351,
		90351
	],
	"./specialities2/otorinolaringologs_lv.json": [
		98062,
		98062
	],
	"./specialities2/otorinolaringologs_ru.json": [
		41136,
		41136
	],
	"./specialities2/pediatrs_en.json": [
		88356,
		88356
	],
	"./specialities2/pediatrs_lv.json": [
		43223,
		43223
	],
	"./specialities2/pediatrs_ru.json": [
		43728,
		43728
	],
	"./specialities2/pneimonologs_en.json": [
		83962,
		83962
	],
	"./specialities2/pneimonologs_lv.json": [
		83610,
		83610
	],
	"./specialities2/pneimonologs_ru.json": [
		90076,
		90076
	],
	"./specialities2/proktologs_en.json": [
		80670,
		80670
	],
	"./specialities2/proktologs_lv.json": [
		57603,
		57603
	],
	"./specialities2/proktologs_ru.json": [
		62528,
		62528
	],
	"./specialities2/psihiatrs_en.json": [
		57418,
		57418
	],
	"./specialities2/psihiatrs_lv.json": [
		32072,
		32072
	],
	"./specialities2/psihiatrs_ru.json": [
		63531,
		63531
	],
	"./specialities2/psihologs_en.json": [
		23070,
		23070
	],
	"./specialities2/psihologs_lv.json": [
		52894,
		52894
	],
	"./specialities2/psihologs_ru.json": [
		4711,
		4711
	],
	"./specialities2/psihoterapeits_en.json": [
		10257,
		10257
	],
	"./specialities2/psihoterapeits_lv.json": [
		9240,
		9240
	],
	"./specialities2/psihoterapeits_ru.json": [
		2552,
		2552
	],
	"./specialities2/reimatologs_en.json": [
		6844,
		6844
	],
	"./specialities2/reimatologs_lv.json": [
		19753,
		19753
	],
	"./specialities2/reimatologs_ru.json": [
		60924,
		60924
	],
	"./specialities2/sirds-kirurgs_en.json": [
		29681,
		29681
	],
	"./specialities2/sirds-kirurgs_lv.json": [
		36871,
		36871
	],
	"./specialities2/sirds-kirurgs_ru.json": [
		29501,
		29501
	],
	"./specialities2/sporta-arsts_en.json": [
		88935,
		88935
	],
	"./specialities2/sporta-arsts_lv.json": [
		77687,
		77687
	],
	"./specialities2/sporta-arsts_ru.json": [
		56608,
		56608
	],
	"./specialities2/torakalais-kirurgs_en.json": [
		35409,
		35409
	],
	"./specialities2/torakalais-kirurgs_lv.json": [
		33572,
		33572
	],
	"./specialities2/torakalais-kirurgs_ru.json": [
		69657,
		69657
	],
	"./specialities2/traumotologs-ortopeds_en.json": [
		19495,
		19495
	],
	"./specialities2/traumotologs-ortopeds_lv.json": [
		42460,
		42460
	],
	"./specialities2/traumotologs-ortopeds_ru.json": [
		57221,
		57221
	],
	"./specialities2/trihologs_en.json": [
		42906,
		42906
	],
	"./specialities2/trihologs_lv.json": [
		70986,
		70986
	],
	"./specialities2/trihologs_ru.json": [
		30993,
		30993
	],
	"./specialities2/urologs_en.json": [
		28237,
		28237
	],
	"./specialities2/urologs_lv.json": [
		60535,
		60535
	],
	"./specialities2/urologs_ru.json": [
		53074,
		53074
	],
	"./specialities2/uztura-specialists_en.json": [
		41361,
		41361
	],
	"./specialities2/uztura-specialists_lv.json": [
		17658,
		17658
	],
	"./specialities2/uztura-specialists_ru.json": [
		54924,
		54924
	],
	"./specialities2/vecmate_en.json": [
		41370,
		41370
	],
	"./specialities2/vecmate_lv.json": [
		42361,
		42361
	],
	"./specialities2/vecmate_ru.json": [
		40425,
		40425
	],
	"./specialities2/venerologs_en.json": [
		69432,
		69432
	],
	"./specialities2/venerologs_lv.json": [
		67976,
		67976
	],
	"./specialities2/venerologs_ru.json": [
		20822,
		20822
	],
	"./specialities2_en.json": [
		52767,
		52767
	],
	"./specialities2_lv.json": [
		54186,
		54186
	],
	"./specialities2_ru.json": [
		85566,
		85566
	],
	"./specialities_en.json": [
		31995,
		31995
	],
	"./specialities_lv.json": [
		67550,
		67550
	],
	"./specialities_ru.json": [
		74667,
		74667
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 73113;
module.exports = webpackAsyncContext;